import * as i0 from '@angular/core';
import { Injectable, Component, Inject, Input, Pipe, NgModule } from '@angular/core';
import { Subject, BehaviorSubject, combineLatest } from 'rxjs';
import { saveAs } from 'file-saver';
import { map, take as take$1, pluck, takeUntil } from 'rxjs/operators';
import * as CryptoJS from 'crypto-js';
import * as i1 from '@angular/common/http';
import * as i1$2 from '@angular/forms';
import { FormGroup, FormControl, FormArray, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import moment from 'moment';
import { DeleteDialogLibraryComponent, DeleteDialogLibraryModule } from 'delete-dialog-library';
import { DeleteDialogConfigurations } from 'dialog-configuration-library';
import { environment } from 'environment-configurations';
import * as i1$1 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import * as i3 from 'custom-dropdown';
import * as i4 from 'fb-custom-date-picker-group';
import * as i5 from 'custom-radio-button';
import * as i6 from '@angular/platform-browser';
import * as i7 from 'ngx-toastr';
import * as i8 from 'file-upload-library';
import * as i9 from 'reference-library';
import * as i10 from 'primeng/dynamicdialog';
import * as i11 from '@angular/router';
import * as i13 from '@angular/common';
import * as i14 from 'primeng/calendar';
import * as i15 from 'primeng/radiobutton';
import * as i16 from 'primeng/dropdown';
import * as i17 from 'primeng/api';
import * as i18 from 'primeng/checkbox';
import * as i19 from 'primeng/inputtext';
import * as i20 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i21 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i22 from 'primeng/button';
import * as i23 from 'primeng/tooltip';
import * as i24 from 'primeng/table';
import { PrimengLibraryModule } from 'primeng-library';
import { MatDividerModule } from '@angular/material/divider';
import { FileUploadModule } from 'primeng/fileupload';

class LibCreateInvoiceService {
    constructor(http) {
        this.http = http;
        this.formDataIdChanges = new Subject();
        this.onLoadResponseSubject = new BehaviorSubject(null);
        this.invoicingValuetemp = new BehaviorSubject({});
        this.invoicingtempFlag = new BehaviorSubject({});
        this.invoicingbillingValuetemp = new BehaviorSubject({});
        this.grandTotal = 0;
        this.storedGetTermsDocs = [];
        this.clientUploadedFiles = [];
        this.durationUploadedFiles = [];
    }
    setSelectedCurrency(currency) {
        this.selectedCurrency = currency;
    }
    getSelectedCurrency() {
        return this.selectedCurrency;
    }
    getGrandTotal() {
        return this.grandTotal;
    }
    setGrandTotal(total) {
        this.grandTotal = total;
    }
    sendInvoicingvaluetemp(value) {
        this.invoicingValuetemp.next({ invoice: value });
    }
    settempinvoiceflag(value) {
        this.invoicingtempFlag.next({ invoice: value });
    }
    getInvoicingvaluetemp() {
        return this.invoicingValuetemp.asObservable();
    }
    gettempinvoiceflag() {
        return this.invoicingtempFlag.asObservable();
    }
    getInvoicingbillingvaluetemp() {
        return this.invoicingbillingValuetemp.asObservable();
    }
    sendInvoicingbillingvaluetemp(value) {
        return this.invoicingbillingValuetemp.next({ invoice: value });
    }
    setClientUploadedFiles(files) {
        this.clientUploadedFiles = files;
    }
    getClientUploadedFiles() {
        return this.clientUploadedFiles;
    }
    clearClientUploadedFiles() {
        this.clientUploadedFiles = [];
    }
    setDurationUploadedFiles(files) {
        this.durationUploadedFiles = files;
    }
    getDurationUploadedFiles() {
        return this.durationUploadedFiles;
    }
    clearDurationUploadedFiles() {
        this.durationUploadedFiles = [];
    }
    setStoredGetTermsDocs(files) {
        this.storedGetTermsDocs = files;
    }
    getStoredGetTermsDocs() {
        return this.storedGetTermsDocs;
    }
    getInvoiceNo() {
        return this.http.get(`/vd/formBuilder/invoice/invoiceNumber`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    getCurrencyCode() {
        var encryptedText = this.toEncrypt('FB_HIRING_CURRENCY');
        return this.http.get(`/vd/dataSource/${encryptedText}/elements`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    getBilledByDetails() {
        return this.http.get(`/vd/formBuilder/employee/company/details`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    getBilledToDetails(clientId) {
        return this.http.get(`/vd/formBuilder/client/${clientId}/company/details`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    getBillingDetails(projectId, employeeId, startDate, endDate) {
        return this.http.get(`/vd/formBuilder/timesheet/project/${projectId}/employee/${employeeId}/details?endDate=${endDate}&startDate=${startDate}`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    getTermsDetails() {
        return this.http.get(`/vd/formBuilder/company/termsConditions`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    uploadDocument(url, payload) {
        return this.http.post(url, payload).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    getUploadedDocument(url) {
        return this.http.get(url).pipe(map((response) => {
            if (response && (response.status === 200 || response.status === 204)) {
                return response;
            }
        }));
    }
    deleteUploadDocument(url) {
        return this.http.delete(url).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    downloadDocuments(path, fileName) {
        this.http.get(path, { responseType: "arraybuffer" })
            .pipe(take$1(1))
            .subscribe(pdf => {
            const blob = new Blob([pdf], { type: 'application/pdf' });
            saveAs(blob, fileName);
        });
    }
    getInvTemplateDetails(templateId) {
        return this.http.get(`/vd/fb/get/invoice/templateBuilderId/${templateId}`);
    }
    getDataSourceList(dataSourceType) {
        return this.http.get(`/vd/dataSource/${dataSourceType}/elements`).pipe(pluck("data"), map((data) => {
            return data;
        }));
    }
    getInvoicePreviewDetails(templateId, payload) {
        return this.http.post(`/vd/formBuilder/client/invoice/document/reminderTemplatePreview/templateBuilderId/${templateId}`, payload).pipe(map((response) => {
            if (response.status === 200) {
                return (response === null || response === void 0 ? void 0 : response.data) || null;
            }
            else {
                return null;
            }
        }));
    }
    toEncrypt(_data) {
        var pharase = 'c63a423527b24f65';
        var data = _data;
        var key = CryptoJS.enc.Latin1.parse(pharase);
        var iv = CryptoJS.enc.Latin1.parse(pharase);
        var encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv, mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.ZeroPadding
        }).toString();
        var e64 = CryptoJS.enc.Base64.parse(encrypted);
        var eHex = e64.toString(CryptoJS.enc.Hex);
        return this.encriptedData = eHex;
    }
}
LibCreateInvoiceService.ɵfac = function LibCreateInvoiceService_Factory(t) { return new (t || LibCreateInvoiceService)(i0.ɵɵinject(i1.HttpClient)); };
LibCreateInvoiceService.ɵprov = i0.ɵɵdefineInjectable({ token: LibCreateInvoiceService, factory: LibCreateInvoiceService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibCreateInvoiceService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

class TemplatePreviewDialog {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
    }
    close() {
        this.dialogRef.close();
    }
}
TemplatePreviewDialog.ɵfac = function TemplatePreviewDialog_Factory(t) { return new (t || TemplatePreviewDialog)(i0.ɵɵdirectiveInject(i1$1.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
TemplatePreviewDialog.ɵcmp = i0.ɵɵdefineComponent({ type: TemplatePreviewDialog, selectors: [["app-template-preview-dialog"]], decls: 8, vars: 1, consts: [["mat-dialog-title", ""], [1, "col-md-12", "p-0", "row", "delete-header"], [1, "col-md-10", "p-0"], [1, "col-md-2", "p-0", "justify-content-end", "d-flex"], [1, "close-icon", "pi", "pi-times", 3, "click"], [1, "html-viewer", 3, "innerHtml"]], template: function TemplatePreviewDialog_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "h2", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtext(3, " Email Template Preview ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵelementStart(5, "i", 4);
        i0.ɵɵlistener("click", function TemplatePreviewDialog_Template_i_click_5_listener() { return ctx.close(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "mat-dialog-content");
        i0.ɵɵelement(7, "div", 5);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("innerHtml", ctx.data.content, i0.ɵɵsanitizeHtml);
    } }, directives: [i1$1.MatDialogTitle, i1$1.MatDialogContent], styles: [".html-viewer[_ngcontent-%COMP%]{max-height:400px;overflow-y:auto;padding:10px;border:1px solid #ddd;background-color:#f9f9f9}.close-icon[_ngcontent-%COMP%]{color:#fff;background-color:#553b7c;padding:10px;border-radius:20px;cursor:pointer;font-size:10px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TemplatePreviewDialog, [{
        type: Component,
        args: [{
                selector: 'app-template-preview-dialog',
                templateUrl: "./lib-reminder-preview.component.html",
                styleUrls: ["./lib-reminder-preview.component.scss"]
            }]
    }], function () { return [{ type: i1$1.MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, null); })();

function LibCreateInvoiceComponent_div_3_ng_template_130_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 85);
    i0.ɵɵelementStart(1, "div", 86);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const currency_r10 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", currency_r10.name, " ");
} }
function LibCreateInvoiceComponent_div_3_div_141_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 57);
    i0.ɵɵtext(1, "Tax");
    i0.ɵɵelementEnd();
} }
function LibCreateInvoiceComponent_div_3_div_145_small_6_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
function LibCreateInvoiceComponent_div_3_div_145_small_6_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Maximum limit exceeded");
    i0.ɵɵelementEnd();
} }
function LibCreateInvoiceComponent_div_3_div_145_small_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 102);
    i0.ɵɵtemplate(1, LibCreateInvoiceComponent_div_3_div_145_small_6_span_1_Template, 2, 0, "span", 3);
    i0.ɵɵtemplate(2, LibCreateInvoiceComponent_div_3_div_145_small_6_span_2_Template, 2, 0, "span", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r11 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r11.controls["desc"] == null ? null : item_r11.controls["desc"].errors["required"]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r11.controls["desc"] == null ? null : item_r11.controls["desc"].errors["maxlength"]);
} }
function LibCreateInvoiceComponent_div_3_div_145_small_12_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Maximum limit exceeded");
    i0.ɵɵelementEnd();
} }
function LibCreateInvoiceComponent_div_3_div_145_small_12_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
function LibCreateInvoiceComponent_div_3_div_145_small_12_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Please enter only numbers/decimals");
    i0.ɵɵelementEnd();
} }
function LibCreateInvoiceComponent_div_3_div_145_small_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 102);
    i0.ɵɵtemplate(1, LibCreateInvoiceComponent_div_3_div_145_small_12_span_1_Template, 2, 0, "span", 3);
    i0.ɵɵtemplate(2, LibCreateInvoiceComponent_div_3_div_145_small_12_span_2_Template, 2, 0, "span", 3);
    i0.ɵɵtemplate(3, LibCreateInvoiceComponent_div_3_div_145_small_12_span_3_Template, 2, 0, "span", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r11 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r11.controls["chargableAmount"] == null ? null : item_r11.controls["chargableAmount"].errors["maxlength"]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r11.controls["chargableAmount"] == null ? null : item_r11.controls["chargableAmount"].errors["required"]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r11.controls["chargableAmount"] == null ? null : item_r11.controls["chargableAmount"].errors["pattern"]);
} }
function LibCreateInvoiceComponent_div_3_div_145_small_18_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Maximum limit exceeded");
    i0.ɵɵelementEnd();
} }
function LibCreateInvoiceComponent_div_3_div_145_small_18_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
function LibCreateInvoiceComponent_div_3_div_145_small_18_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Please enter only numbers");
    i0.ɵɵelementEnd();
} }
function LibCreateInvoiceComponent_div_3_div_145_small_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 102);
    i0.ɵɵtemplate(1, LibCreateInvoiceComponent_div_3_div_145_small_18_span_1_Template, 2, 0, "span", 3);
    i0.ɵɵtemplate(2, LibCreateInvoiceComponent_div_3_div_145_small_18_span_2_Template, 2, 0, "span", 3);
    i0.ɵɵtemplate(3, LibCreateInvoiceComponent_div_3_div_145_small_18_span_3_Template, 2, 0, "span", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r11 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r11.controls["workingHours"] == null ? null : item_r11.controls["workingHours"].errors["maxlength"]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r11.controls["workingHours"] == null ? null : item_r11.controls["workingHours"].errors["required"]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r11.controls["workingHours"] == null ? null : item_r11.controls["workingHours"].errors["pattern"]);
} }
function LibCreateInvoiceComponent_div_3_div_145_div_19_small_5_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Maximum limit exceeded");
    i0.ɵɵelementEnd();
} }
function LibCreateInvoiceComponent_div_3_div_145_div_19_small_5_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
function LibCreateInvoiceComponent_div_3_div_145_div_19_small_5_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Please enter only numbers");
    i0.ɵɵelementEnd();
} }
function LibCreateInvoiceComponent_div_3_div_145_div_19_small_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 102);
    i0.ɵɵtemplate(1, LibCreateInvoiceComponent_div_3_div_145_div_19_small_5_span_1_Template, 2, 0, "span", 3);
    i0.ɵɵtemplate(2, LibCreateInvoiceComponent_div_3_div_145_div_19_small_5_span_2_Template, 2, 0, "span", 3);
    i0.ɵɵtemplate(3, LibCreateInvoiceComponent_div_3_div_145_div_19_small_5_span_3_Template, 2, 0, "span", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r11 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r11.controls["tax"] == null ? null : item_r11.controls["tax"].errors["maxlength"]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r11.controls["tax"] == null ? null : item_r11.controls["tax"].errors["required"]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r11.controls["tax"] == null ? null : item_r11.controls["tax"].errors["pattern"]);
} }
function LibCreateInvoiceComponent_div_3_div_145_div_19_Template(rf, ctx) { if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 92);
    i0.ɵɵelementStart(1, "span", 93);
    i0.ɵɵelementStart(2, "span", 94);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 103);
    i0.ɵɵlistener("change", function LibCreateInvoiceComponent_div_3_div_145_div_19_Template_input_change_4_listener() { i0.ɵɵrestoreView(_r35); const ctx_r34 = i0.ɵɵnextContext(3); return ctx_r34.storedata(); })("keyup", function LibCreateInvoiceComponent_div_3_div_145_div_19_Template_input_keyup_4_listener() { i0.ɵɵrestoreView(_r35); const ctx_r37 = i0.ɵɵnextContext(); const item_r11 = ctx_r37.$implicit; const i_r12 = ctx_r37.index; const ctx_r36 = i0.ɵɵnextContext(2); return ctx_r36.showTotal(item_r11, i_r12); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, LibCreateInvoiceComponent_div_3_div_145_div_19_small_5_Template, 4, 3, "small", 91);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r11 = i0.ɵɵnextContext().$implicit;
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r16.selectedcurrencyicon);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (item_r11.controls["tax"] == null ? null : item_r11.controls["tax"].errors) && (item_r11.controls["tax"] == null ? null : item_r11.controls["tax"].touched));
} }
function LibCreateInvoiceComponent_div_3_div_145_div_25_Template(rf, ctx) { if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 104);
    i0.ɵɵelementStart(1, "div", 105);
    i0.ɵɵelementStart(2, "button", 106);
    i0.ɵɵlistener("click", function LibCreateInvoiceComponent_div_3_div_145_div_25_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r41); const i_r12 = i0.ɵɵnextContext().index; const ctx_r39 = i0.ɵɵnextContext(2); return ctx_r39.removeBillingItem(i_r12); });
    i0.ɵɵelementStart(3, "mat-icon", 107);
    i0.ɵɵtext(4, " remove_circle_outline ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function LibCreateInvoiceComponent_div_3_div_145_Template(rf, ctx) { if (rf & 1) {
    const _r43 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelementStart(2, "div", 87);
    i0.ɵɵelementStart(3, "div", 88);
    i0.ɵɵelementStart(4, "div", 89);
    i0.ɵɵelementStart(5, "input", 90);
    i0.ɵɵlistener("change", function LibCreateInvoiceComponent_div_3_div_145_Template_input_change_5_listener() { i0.ɵɵrestoreView(_r43); const ctx_r42 = i0.ɵɵnextContext(2); return ctx_r42.storedata(); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, LibCreateInvoiceComponent_div_3_div_145_small_6_Template, 3, 2, "small", 91);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 92);
    i0.ɵɵelementStart(8, "span", 93);
    i0.ɵɵelementStart(9, "span", 94);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "input", 95);
    i0.ɵɵlistener("change", function LibCreateInvoiceComponent_div_3_div_145_Template_input_change_11_listener() { i0.ɵɵrestoreView(_r43); const ctx_r44 = i0.ɵɵnextContext(2); return ctx_r44.storedata(); })("keyup", function LibCreateInvoiceComponent_div_3_div_145_Template_input_keyup_11_listener() { i0.ɵɵrestoreView(_r43); const item_r11 = ctx.$implicit; const i_r12 = ctx.index; const ctx_r45 = i0.ɵɵnextContext(2); return ctx_r45.showTotal(item_r11, i_r12); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, LibCreateInvoiceComponent_div_3_div_145_small_12_Template, 4, 3, "small", 91);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 92);
    i0.ɵɵelementStart(14, "span", 93);
    i0.ɵɵelementStart(15, "span", 96);
    i0.ɵɵelement(16, "img", 97);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "input", 98);
    i0.ɵɵlistener("change", function LibCreateInvoiceComponent_div_3_div_145_Template_input_change_17_listener() { i0.ɵɵrestoreView(_r43); const ctx_r46 = i0.ɵɵnextContext(2); return ctx_r46.storedata(); })("keyup", function LibCreateInvoiceComponent_div_3_div_145_Template_input_keyup_17_listener() { i0.ɵɵrestoreView(_r43); const item_r11 = ctx.$implicit; const i_r12 = ctx.index; const ctx_r47 = i0.ɵɵnextContext(2); return ctx_r47.showTotal(item_r11, i_r12); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(18, LibCreateInvoiceComponent_div_3_div_145_small_18_Template, 4, 3, "small", 91);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(19, LibCreateInvoiceComponent_div_3_div_145_div_19_Template, 6, 2, "div", 99);
    i0.ɵɵelementStart(20, "div", 92);
    i0.ɵɵelementStart(21, "span", 93);
    i0.ɵɵelementStart(22, "span", 94);
    i0.ɵɵtext(23);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(24, "input", 100);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(25, LibCreateInvoiceComponent_div_3_div_145_div_25_Template, 5, 0, "div", 101);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r11 = ctx.$implicit;
    const i_r12 = ctx.index;
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("formGroupName", i_r12);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", (item_r11.controls["desc"] == null ? null : item_r11.controls["desc"].errors) && (item_r11.controls["desc"] == null ? null : item_r11.controls["desc"].touched));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r4.selectedcurrencyicon);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("min", 0)("max", 100000);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (item_r11.controls["chargableAmount"] == null ? null : item_r11.controls["chargableAmount"].errors) && (item_r11.controls["chargableAmount"] == null ? null : item_r11.controls["chargableAmount"].touched));
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", (item_r11.controls["workingHours"] == null ? null : item_r11.controls["workingHours"].errors) && (item_r11.controls["workingHours"] == null ? null : item_r11.controls["workingHours"].touched));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.selectedCurrencyType && ctx_r4.selectedCurrencyType.trim() !== "USD");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r4.selectedcurrencyicon);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("readonly", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i_r12 != 0);
} }
function LibCreateInvoiceComponent_div_3_div_166_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "strong", 108);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" ", ctx_r6.numberToWordsWithDecimals(ctx_r6.grandTotal), " ", ctx_r6.selectedCurrencyType, " only");
} }
function LibCreateInvoiceComponent_div_3_div_173_Template(rf, ctx) { if (rf & 1) {
    const _r51 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelementStart(1, "div", 109);
    i0.ɵɵelementStart(2, "span", 110);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "input", 111);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 112);
    i0.ɵɵelementStart(6, "div", 5);
    i0.ɵɵelementStart(7, "div", 1);
    i0.ɵɵelementStart(8, "div", 113);
    i0.ɵɵelementStart(9, "button", 114);
    i0.ɵɵlistener("click", function LibCreateInvoiceComponent_div_3_div_173_Template_button_click_9_listener() { i0.ɵɵrestoreView(_r51); const i_r49 = ctx.index; const ctx_r50 = i0.ɵɵnextContext(2); return ctx_r50.editTerms(i_r49); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 113);
    i0.ɵɵelementStart(11, "button", 115);
    i0.ɵɵlistener("click", function LibCreateInvoiceComponent_div_3_div_173_Template_button_click_11_listener() { i0.ɵɵrestoreView(_r51); const i_r49 = ctx.index; const ctx_r52 = i0.ɵɵnextContext(2); return ctx_r52.deleteTerms(i_r49); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r48 = ctx.$implicit;
    const i_r49 = ctx.index;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroupName", i_r49);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i_r49 + 1, ".");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("readonly", item_r48.isEditable);
} }
function LibCreateInvoiceComponent_div_3_div_179_Template(rf, ctx) { if (rf & 1) {
    const _r56 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 116);
    i0.ɵɵelementStart(1, "div", 117);
    i0.ɵɵelementStart(2, "p");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 118);
    i0.ɵɵelementStart(5, "button", 119);
    i0.ɵɵlistener("click", function LibCreateInvoiceComponent_div_3_div_179_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r56); const item_r53 = ctx.$implicit; const ctx_r55 = i0.ɵɵnextContext(2); return ctx_r55.viewDoc(item_r53.get("fileLocation").value); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "button", 115);
    i0.ɵɵlistener("click", function LibCreateInvoiceComponent_div_3_div_179_Template_button_click_6_listener() { i0.ɵɵrestoreView(_r56); const i_r54 = ctx.index; const ctx_r57 = i0.ɵɵnextContext(2); return ctx_r57.deleteDoc(i_r54); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r53 = ctx.$implicit;
    const i_r54 = ctx.index;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroupName", i_r54);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r53.get("fileName").value);
} }
function LibCreateInvoiceComponent_div_3_div_188_ng_template_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "th");
    i0.ɵɵtext(2, "REMINDER DATE");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "th");
    i0.ɵɵtext(4, "REMINDER TIME");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "th");
    i0.ɵɵtext(6, "EMAIL TEMPLATE");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "th");
    i0.ɵɵtext(8, "CREATED DATE");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "th");
    i0.ɵɵtext(10, "CREATED TIME");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "th");
    i0.ɵɵtext(12, "ACTIONS");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function LibCreateInvoiceComponent_div_3_div_188_ng_template_25_Template(rf, ctx) { if (rf & 1) {
    const _r64 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td");
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "td", 138);
    i0.ɵɵelementStart(12, "div", 139);
    i0.ɵɵelementStart(13, "button", 140);
    i0.ɵɵlistener("click", function LibCreateInvoiceComponent_div_3_div_188_ng_template_25_Template_button_click_13_listener() { i0.ɵɵrestoreView(_r64); const rowIndex_r62 = ctx.rowIndex; const ctx_r63 = i0.ɵɵnextContext(3); return ctx_r63.openTemplatePreview(rowIndex_r62); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "button", 141);
    i0.ɵɵlistener("click", function LibCreateInvoiceComponent_div_3_div_188_ng_template_25_Template_button_click_14_listener() { i0.ɵɵrestoreView(_r64); const rowIndex_r62 = ctx.rowIndex; const ctx_r65 = i0.ɵɵnextContext(3); return ctx_r65.onEdit(rowIndex_r62); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "button", 142);
    i0.ɵɵlistener("click", function LibCreateInvoiceComponent_div_3_div_188_ng_template_25_Template_button_click_15_listener() { i0.ɵɵrestoreView(_r64); const rowIndex_r62 = ctx.rowIndex; const ctx_r66 = i0.ɵɵnextContext(3); return ctx_r66.onDelete(rowIndex_r62); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r61 = ctx.$implicit;
    let tmp_0_0 = null;
    let tmp_1_0 = null;
    let tmp_2_0 = null;
    let tmp_3_0 = null;
    let tmp_4_0 = null;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((tmp_0_0 = row_r61.get("reminderDate")) == null ? null : tmp_0_0.value);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((tmp_1_0 = row_r61.get("reminderTime")) == null ? null : tmp_1_0.value);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((tmp_2_0 = row_r61.get("emailTemplates")) == null ? null : tmp_2_0.value);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((tmp_3_0 = row_r61.get("createdDate")) == null ? null : tmp_3_0.value);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((tmp_4_0 = row_r61.get("createdTime")) == null ? null : tmp_4_0.value);
} }
function LibCreateInvoiceComponent_div_3_div_188_ng_template_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 143);
    i0.ɵɵelementStart(2, "div", 144);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4, "No Data");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
const _c0 = function () { return { "width": "100%" }; };
function LibCreateInvoiceComponent_div_3_div_188_Template(rf, ctx) { if (rf & 1) {
    const _r68 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelementStart(1, "div", 120);
    i0.ɵɵelementStart(2, "div", 121);
    i0.ɵɵelementStart(3, "div", 122);
    i0.ɵɵelementStart(4, "h6", 12);
    i0.ɵɵtext(5, "Reminder Date and Time");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div");
    i0.ɵɵelementStart(7, "div", 123);
    i0.ɵɵelementStart(8, "div", 124);
    i0.ɵɵelementStart(9, "p-calendar", 125);
    i0.ɵɵlistener("onSelect", function LibCreateInvoiceComponent_div_3_div_188_Template_p_calendar_onSelect_9_listener($event) { i0.ɵɵrestoreView(_r68); const ctx_r67 = i0.ɵɵnextContext(2); return ctx_r67.dateChange($event, "reminderDate"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 126);
    i0.ɵɵelementStart(11, "p-calendar", 127);
    i0.ɵɵlistener("onSelect", function LibCreateInvoiceComponent_div_3_div_188_Template_p_calendar_onSelect_11_listener($event) { i0.ɵɵrestoreView(_r68); const ctx_r69 = i0.ɵɵnextContext(2); return ctx_r69.timeChange($event, "reminderTime"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 128);
    i0.ɵɵelementStart(13, "div", 129);
    i0.ɵɵelementStart(14, "h6", 12);
    i0.ɵɵtext(15, "Email Template");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(16, "p-dropdown", 130);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 131);
    i0.ɵɵelementStart(18, "button", 132);
    i0.ɵɵlistener("click", function LibCreateInvoiceComponent_div_3_div_188_Template_button_click_18_listener() { i0.ɵɵrestoreView(_r68); const ctx_r70 = i0.ɵɵnextContext(2); return ctx_r70.addGridEditorField(); });
    i0.ɵɵtext(19, " ADD ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "button", 133);
    i0.ɵɵlistener("click", function LibCreateInvoiceComponent_div_3_div_188_Template_button_click_20_listener() { i0.ɵɵrestoreView(_r68); const ctx_r71 = i0.ɵɵnextContext(2); return ctx_r71.onReset(); });
    i0.ɵɵtext(21, " CANCEL ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "div", 1);
    i0.ɵɵelementStart(23, "p-table", 134);
    i0.ɵɵtemplate(24, LibCreateInvoiceComponent_div_3_div_188_ng_template_24_Template, 13, 0, "ng-template", 135);
    i0.ɵɵtemplate(25, LibCreateInvoiceComponent_div_3_div_188_ng_template_25_Template, 16, 5, "ng-template", 136);
    i0.ɵɵtemplate(26, LibCreateInvoiceComponent_div_3_div_188_ng_template_26_Template, 5, 0, "ng-template", 137);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("showIcon", true)("minDate", ctx_r9.currentDate);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("showIcon", true)("disabled", !ctx_r9.invoiceForm.get("reminderDate").value)("icon", "pi pi-clock");
    i0.ɵɵadvance(5);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(10, _c0));
    i0.ɵɵproperty("options", ctx_r9.emailTemplates);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", !ctx_r9.isAddButtonEnabled());
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("value", ctx_r9.emailReminderFields.controls);
} }
const _c1 = function () { return { "margin-right": "12px" }; };
function LibCreateInvoiceComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r73 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 5);
    i0.ɵɵelementStart(2, "div", 6);
    i0.ɵɵelement(3, "img", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 6);
    i0.ɵɵelementStart(5, "div", 5);
    i0.ɵɵelementStart(6, "div", 8);
    i0.ɵɵelementStart(7, "h6", 9);
    i0.ɵɵtext(8, "Invoice No.");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(9, "input", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 11);
    i0.ɵɵelementStart(11, "div", 8);
    i0.ɵɵelementStart(12, "h6", 12);
    i0.ɵɵtext(13, "Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "p-calendar", 13);
    i0.ɵɵlistener("onSelect", function LibCreateInvoiceComponent_div_3_Template_p_calendar_onSelect_14_listener($event) { i0.ɵɵrestoreView(_r73); const ctx_r72 = i0.ɵɵnextContext(); return ctx_r72.dateChange($event, "invoiceDate"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 11);
    i0.ɵɵelementStart(16, "div", 8);
    i0.ɵɵelementStart(17, "div", 14);
    i0.ɵɵelementStart(18, "h6", 15);
    i0.ɵɵtext(19, "Payment Terms(Days)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "input", 16);
    i0.ɵɵlistener("input", function LibCreateInvoiceComponent_div_3_Template_input_input_20_listener($event) { i0.ɵɵrestoreView(_r73); const ctx_r74 = i0.ɵɵnextContext(); return ctx_r74.onNumberInputChange($event.target.value); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "div", 17);
    i0.ɵɵelementStart(22, "div", 8);
    i0.ɵɵelementStart(23, "h6", 12);
    i0.ɵɵtext(24, "Due Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "p-calendar", 18);
    i0.ɵɵlistener("onSelect", function LibCreateInvoiceComponent_div_3_Template_p_calendar_onSelect_25_listener($event) { i0.ɵɵrestoreView(_r73); const ctx_r75 = i0.ɵɵnextContext(); return ctx_r75.dateChange($event, "invoiceDueDate"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "div", 17);
    i0.ɵɵelementStart(27, "div", 8);
    i0.ɵɵelementStart(28, "h6", 12);
    i0.ɵɵtext(29, "Generate Combined PDF (Invoice + Timesheet)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(30, "div", 1);
    i0.ɵɵelement(31, "p-radioButton", 19);
    i0.ɵɵelement(32, "p-radioButton", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(33, "div", 21);
    i0.ɵɵelementStart(34, "div", 22);
    i0.ɵɵelementStart(35, "h4");
    i0.ɵɵtext(36, "Billing Details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(37, "div", 23);
    i0.ɵɵelementStart(38, "div", 24);
    i0.ɵɵelementStart(39, "h6");
    i0.ɵɵtext(40, "Billed By ");
    i0.ɵɵelementStart(41, "i");
    i0.ɵɵtext(42, "(Your Firm Details)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(43, "div", 5);
    i0.ɵɵelementStart(44, "div", 1);
    i0.ɵɵelementStart(45, "p", 25);
    i0.ɵɵtext(46, "Clients/Company Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(47, "input", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(48, "div", 5);
    i0.ɵɵelementStart(49, "div", 6);
    i0.ɵɵelementStart(50, "label", 27);
    i0.ɵɵtext(51, "Your email");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(52, "input", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(53, "div", 6);
    i0.ɵɵelementStart(54, "label", 27);
    i0.ɵɵtext(55, "Phone Number");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(56, "div", 29);
    i0.ɵɵelement(57, "input", 30);
    i0.ɵɵelement(58, "input", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(59, "div", 5);
    i0.ɵɵelementStart(60, "div", 1);
    i0.ɵɵelementStart(61, "label", 27);
    i0.ɵɵtext(62, "Address");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(63, "input", 32);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(64, "div", 17);
    i0.ɵɵelementStart(65, "div", 6);
    i0.ɵɵelementStart(66, "p", 25);
    i0.ɵɵtext(67, "Country");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(68, "input", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(69, "div", 6);
    i0.ɵɵelementStart(70, "p", 25);
    i0.ɵɵtext(71, "State");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(72, "input", 34);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(73, "div", 35);
    i0.ɵɵelementStart(74, "div", 6);
    i0.ɵɵelementStart(75, "p", 25);
    i0.ɵɵtext(76, "City");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(77, "input", 36);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(78, "div", 6);
    i0.ɵɵelementStart(79, "p", 25);
    i0.ɵɵtext(80, "Zip/Postal code");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(81, "input", 37);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(82, "div", 38);
    i0.ɵɵelementStart(83, "div", 24);
    i0.ɵɵelementStart(84, "h6");
    i0.ɵɵtext(85, "Billed To");
    i0.ɵɵelementStart(86, "i");
    i0.ɵɵtext(87, "(Client Details)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(88, "div", 5);
    i0.ɵɵelementStart(89, "div", 1);
    i0.ɵɵelementStart(90, "p", 25);
    i0.ɵɵtext(91, "Clients Business/Company Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(92, "input", 39);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(93, "div", 5);
    i0.ɵɵelementStart(94, "div", 6);
    i0.ɵɵelementStart(95, "label", 27);
    i0.ɵɵtext(96, "Client Email");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(97, "input", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(98, "div", 6);
    i0.ɵɵelementStart(99, "label", 27);
    i0.ɵɵtext(100, "Phone Number");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(101, "div", 29);
    i0.ɵɵelement(102, "input", 41);
    i0.ɵɵelement(103, "input", 42);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(104, "div", 5);
    i0.ɵɵelementStart(105, "div", 1);
    i0.ɵɵelementStart(106, "label", 27);
    i0.ɵɵtext(107, "Address");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(108, "input", 43);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(109, "div", 17);
    i0.ɵɵelementStart(110, "div", 6);
    i0.ɵɵelementStart(111, "p", 25);
    i0.ɵɵtext(112, "Country");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(113, "input", 44);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(114, "div", 6);
    i0.ɵɵelementStart(115, "p", 25);
    i0.ɵɵtext(116, "State");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(117, "input", 45);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(118, "div", 35);
    i0.ɵɵelementStart(119, "div", 6);
    i0.ɵɵelementStart(120, "p", 25);
    i0.ɵɵtext(121, "City");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(122, "input", 46);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(123, "div", 6);
    i0.ɵɵelementStart(124, "p", 25);
    i0.ɵɵtext(125, "Zip/Postal code");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(126, "input", 47);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(127, "div", 48);
    i0.ɵɵelementStart(128, "div", 49);
    i0.ɵɵelementStart(129, "p-dropdown", 50);
    i0.ɵɵlistener("onChange", function LibCreateInvoiceComponent_div_3_Template_p_dropdown_onChange_129_listener($event) { i0.ɵɵrestoreView(_r73); const ctx_r76 = i0.ɵɵnextContext(); return ctx_r76.convertCurrency($event); });
    i0.ɵɵtemplate(130, LibCreateInvoiceComponent_div_3_ng_template_130_Template, 3, 1, "ng-template", 51);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(131, "div", 52);
    i0.ɵɵelementStart(132, "h4", 53);
    i0.ɵɵtext(133, "Invoice Details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(134, "div", 54);
    i0.ɵɵelementStart(135, "div", 55);
    i0.ɵɵtext(136, "Description");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(137, "div", 56);
    i0.ɵɵtext(138, "Rate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(139, "div", 57);
    i0.ɵɵtext(140, "Hours Worked");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(141, LibCreateInvoiceComponent_div_3_div_141_Template, 2, 0, "div", 58);
    i0.ɵɵelementStart(142, "div", 59);
    i0.ɵɵtext(143, "Amount");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(144, "div", 60);
    i0.ɵɵtemplate(145, LibCreateInvoiceComponent_div_3_div_145_Template, 26, 11, "div", 61);
    i0.ɵɵelementStart(146, "div", 5);
    i0.ɵɵelementStart(147, "div", 62);
    i0.ɵɵelementStart(148, "button", 63);
    i0.ɵɵlistener("click", function LibCreateInvoiceComponent_div_3_Template_button_click_148_listener() { i0.ɵɵrestoreView(_r73); const ctx_r77 = i0.ɵɵnextContext(); return ctx_r77.addBillingItemDTOs("", "create"); });
    i0.ɵɵtext(149, " + Add New Row ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(150, "div", 64);
    i0.ɵɵelementStart(151, "div", 65);
    i0.ɵɵelementStart(152, "div", 29);
    i0.ɵɵelementStart(153, "div", 66);
    i0.ɵɵelementStart(154, "p", 67);
    i0.ɵɵtext(155, "Total");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(156, "div", 68);
    i0.ɵɵelementStart(157, "p");
    i0.ɵɵelementStart(158, "span");
    i0.ɵɵtext(159);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(160);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(161, "div", 29);
    i0.ɵɵelementStart(162, "div", 66);
    i0.ɵɵelementStart(163, "p", 67);
    i0.ɵɵelement(164, "p-checkbox", 69, 70);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(166, LibCreateInvoiceComponent_div_3_div_166_Template, 3, 2, "div", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(167, "div", 71);
    i0.ɵɵelementStart(168, "h5", 72);
    i0.ɵɵtext(169, "TERMS & CONDITIONS");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(170, "h5", 73);
    i0.ɵɵtext(171, "ACTIONS");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(172, "div", 74);
    i0.ɵɵtemplate(173, LibCreateInvoiceComponent_div_3_div_173_Template, 12, 3, "div", 75);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(174, "div", 71);
    i0.ɵɵelementStart(175, "div", 76);
    i0.ɵɵelementStart(176, "h5", 77);
    i0.ɵɵtext(177, "Additional Documents");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(178, "div", 78);
    i0.ɵɵtemplate(179, LibCreateInvoiceComponent_div_3_div_179_Template, 7, 2, "div", 79);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(180, "div", 80);
    i0.ɵɵelementStart(181, "div", 17);
    i0.ɵɵelementStart(182, "div", 1);
    i0.ɵɵelementStart(183, "h6", 12);
    i0.ɵɵtext(184, "Would you like to send email reminder for the invoice");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(185, "div", 81);
    i0.ɵɵelement(186, "p-radioButton", 82);
    i0.ɵɵelement(187, "p-radioButton", 83);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(188, LibCreateInvoiceComponent_div_3_div_188_Template, 27, 11, "div", 84);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r5 = i0.ɵɵreference(165);
    const ctx_r0 = i0.ɵɵnextContext();
    let tmp_28_0 = null;
    let tmp_33_0 = null;
    let tmp_34_0 = null;
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("src", ctx_r0.companyLogoImage, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("readonly", ctx_r0.isEditable);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("showIcon", true);
    i0.ɵɵadvance(11);
    i0.ɵɵproperty("showIcon", true)("disabled", ctx_r0.hasPaymentTerms);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction0(39, _c1))("value", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", false);
    i0.ɵɵadvance(15);
    i0.ɵɵproperty("readonly", ctx_r0.isEditable);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("readonly", ctx_r0.isEditable);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("readonly", ctx_r0.isEditable);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("readonly", ctx_r0.isEditable);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("readonly", ctx_r0.isEditable);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("readonly", ctx_r0.isEditable);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("readonly", ctx_r0.isEditable);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("readonly", ctx_r0.isEditable);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("readonly", ctx_r0.isEditable);
    i0.ɵɵadvance(11);
    i0.ɵɵproperty("readonly", ctx_r0.isEditable);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("readonly", ctx_r0.isEditable);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("readonly", ctx_r0.isEditable);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("readonly", ctx_r0.isEditable);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("readonly", ctx_r0.isEditable);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("readonly", ctx_r0.isEditable);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("readonly", ctx_r0.isEditable);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("readonly", ctx_r0.isEditable);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("readonly", ctx_r0.isEditable);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r0.currencyOptions);
    i0.ɵɵadvance(12);
    i0.ɵɵproperty("ngIf", ctx_r0.selectedCurrencyType && ctx_r0.selectedCurrencyType.trim() !== "USD");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r0.invoiceForm == null ? null : (tmp_28_0 = ctx_r0.invoiceForm.get("billingItemDTOs")) == null ? null : tmp_28_0.controls);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", (ctx_r0.billingItemDTOs == null ? null : ctx_r0.billingItemDTOs.length) == 10);
    i0.ɵɵadvance(11);
    i0.ɵɵtextInterpolate(ctx_r0.selectedcurrencyicon);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.grandTotal, " ");
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", _r5.checked);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngForOf", (tmp_33_0 = ctx_r0.invoiceForm.get("termsAndConditions")) == null ? null : tmp_33_0.controls);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngForOf", (tmp_34_0 = ctx_r0.invoiceForm.get("termsAndConditionsDocs")) == null ? null : tmp_34_0.controls);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction0(40, _c1))("value", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.invoiceForm.controls["emailReminder"].value === true);
} }
function LibCreateInvoiceComponent_div_4_div_34_Template(rf, ctx) { if (rf & 1) {
    const _r83 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 116);
    i0.ɵɵelementStart(1, "div", 117);
    i0.ɵɵelementStart(2, "p");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 118);
    i0.ɵɵelementStart(5, "button", 119);
    i0.ɵɵlistener("click", function LibCreateInvoiceComponent_div_4_div_34_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r83); const item_r80 = ctx.$implicit; const ctx_r82 = i0.ɵɵnextContext(2); return ctx_r82.viewDoc(item_r80.get("fileLocation").value); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "button", 115);
    i0.ɵɵlistener("click", function LibCreateInvoiceComponent_div_4_div_34_Template_button_click_6_listener() { i0.ɵɵrestoreView(_r83); const i_r81 = ctx.index; const ctx_r84 = i0.ɵɵnextContext(2); return ctx_r84.deleteDoc(i_r81); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r80 = ctx.$implicit;
    const i_r81 = ctx.index;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroupName", i_r81);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r80.get("fileName").value);
} }
function LibCreateInvoiceComponent_div_4_div_43_ng_template_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "th");
    i0.ɵɵtext(2, "REMINDER DATE");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "th");
    i0.ɵɵtext(4, "REMINDER TIME");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "th");
    i0.ɵɵtext(6, "EMAIL TEMPLATE");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "th");
    i0.ɵɵtext(8, "CREATED DATE");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "th");
    i0.ɵɵtext(10, "CREATED TIME");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "th");
    i0.ɵɵtext(12, "ACTIONS");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function LibCreateInvoiceComponent_div_4_div_43_ng_template_25_Template(rf, ctx) { if (rf & 1) {
    const _r91 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td");
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "td", 138);
    i0.ɵɵelementStart(12, "div", 139);
    i0.ɵɵelementStart(13, "button", 140);
    i0.ɵɵlistener("click", function LibCreateInvoiceComponent_div_4_div_43_ng_template_25_Template_button_click_13_listener() { i0.ɵɵrestoreView(_r91); const rowIndex_r89 = ctx.rowIndex; const ctx_r90 = i0.ɵɵnextContext(3); return ctx_r90.openTemplatePreview(rowIndex_r89); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "button", 141);
    i0.ɵɵlistener("click", function LibCreateInvoiceComponent_div_4_div_43_ng_template_25_Template_button_click_14_listener() { i0.ɵɵrestoreView(_r91); const rowIndex_r89 = ctx.rowIndex; const ctx_r92 = i0.ɵɵnextContext(3); return ctx_r92.onEdit(rowIndex_r89); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "button", 142);
    i0.ɵɵlistener("click", function LibCreateInvoiceComponent_div_4_div_43_ng_template_25_Template_button_click_15_listener() { i0.ɵɵrestoreView(_r91); const rowIndex_r89 = ctx.rowIndex; const ctx_r93 = i0.ɵɵnextContext(3); return ctx_r93.onDelete(rowIndex_r89); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r88 = ctx.$implicit;
    let tmp_0_0 = null;
    let tmp_1_0 = null;
    let tmp_2_0 = null;
    let tmp_3_0 = null;
    let tmp_4_0 = null;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((tmp_0_0 = row_r88.get("reminderDate")) == null ? null : tmp_0_0.value);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((tmp_1_0 = row_r88.get("reminderTime")) == null ? null : tmp_1_0.value);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((tmp_2_0 = row_r88.get("emailTemplates")) == null ? null : tmp_2_0.value);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((tmp_3_0 = row_r88.get("createdDate")) == null ? null : tmp_3_0.value);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((tmp_4_0 = row_r88.get("createdTime")) == null ? null : tmp_4_0.value);
} }
function LibCreateInvoiceComponent_div_4_div_43_ng_template_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 143);
    i0.ɵɵelementStart(2, "div", 144);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4, "No Data");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function LibCreateInvoiceComponent_div_4_div_43_Template(rf, ctx) { if (rf & 1) {
    const _r95 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelementStart(1, "div", 120);
    i0.ɵɵelementStart(2, "div", 121);
    i0.ɵɵelementStart(3, "div", 122);
    i0.ɵɵelementStart(4, "h6", 12);
    i0.ɵɵtext(5, "Reminder Date and Time");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div");
    i0.ɵɵelementStart(7, "div", 123);
    i0.ɵɵelementStart(8, "div", 124);
    i0.ɵɵelementStart(9, "p-calendar", 125);
    i0.ɵɵlistener("onSelect", function LibCreateInvoiceComponent_div_4_div_43_Template_p_calendar_onSelect_9_listener($event) { i0.ɵɵrestoreView(_r95); const ctx_r94 = i0.ɵɵnextContext(2); return ctx_r94.dateChange($event, "reminderDate"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 126);
    i0.ɵɵelementStart(11, "p-calendar", 127);
    i0.ɵɵlistener("onSelect", function LibCreateInvoiceComponent_div_4_div_43_Template_p_calendar_onSelect_11_listener($event) { i0.ɵɵrestoreView(_r95); const ctx_r96 = i0.ɵɵnextContext(2); return ctx_r96.timeChange($event, "reminderTime"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 128);
    i0.ɵɵelementStart(13, "div", 129);
    i0.ɵɵelementStart(14, "h6", 12);
    i0.ɵɵtext(15, "Email Template");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(16, "p-dropdown", 130);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 131);
    i0.ɵɵelementStart(18, "button", 132);
    i0.ɵɵlistener("click", function LibCreateInvoiceComponent_div_4_div_43_Template_button_click_18_listener() { i0.ɵɵrestoreView(_r95); const ctx_r97 = i0.ɵɵnextContext(2); return ctx_r97.addGridEditorField(); });
    i0.ɵɵtext(19, " ADD ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "button", 133);
    i0.ɵɵlistener("click", function LibCreateInvoiceComponent_div_4_div_43_Template_button_click_20_listener() { i0.ɵɵrestoreView(_r95); const ctx_r98 = i0.ɵɵnextContext(2); return ctx_r98.onReset(); });
    i0.ɵɵtext(21, " CANCEL ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "div", 1);
    i0.ɵɵelementStart(23, "p-table", 134);
    i0.ɵɵtemplate(24, LibCreateInvoiceComponent_div_4_div_43_ng_template_24_Template, 13, 0, "ng-template", 135);
    i0.ɵɵtemplate(25, LibCreateInvoiceComponent_div_4_div_43_ng_template_25_Template, 16, 5, "ng-template", 136);
    i0.ɵɵtemplate(26, LibCreateInvoiceComponent_div_4_div_43_ng_template_26_Template, 5, 0, "ng-template", 137);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r79 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("showIcon", true)("minDate", ctx_r79.currentDate);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("showIcon", true)("disabled", !ctx_r79.invoiceForm.get("reminderDate").value)("icon", "pi pi-clock");
    i0.ɵɵadvance(5);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(10, _c0));
    i0.ɵɵproperty("options", ctx_r79.emailTemplates);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", !ctx_r79.isAddButtonEnabled());
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("value", ctx_r79.emailReminderFields.controls);
} }
function LibCreateInvoiceComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r100 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelementStart(1, "div", 1);
    i0.ɵɵelementStart(2, "div", 5);
    i0.ɵɵelementStart(3, "div", 145);
    i0.ɵɵelementStart(4, "h6", 15);
    i0.ɵɵtext(5, "Invoice No.");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "input", 146);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 11);
    i0.ɵɵelementStart(8, "div", 145);
    i0.ɵɵelementStart(9, "h6", 15);
    i0.ɵɵtext(10, "Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "p-calendar", 147);
    i0.ɵɵlistener("onSelect", function LibCreateInvoiceComponent_div_4_Template_p_calendar_onSelect_11_listener($event) { i0.ɵɵrestoreView(_r100); const ctx_r99 = i0.ɵɵnextContext(); return ctx_r99.dateChange($event, "invoiceDate"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 11);
    i0.ɵɵelementStart(13, "div", 145);
    i0.ɵɵelementStart(14, "h6", 148);
    i0.ɵɵtext(15, "Payment Terms(Days)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "input", 149);
    i0.ɵɵlistener("input", function LibCreateInvoiceComponent_div_4_Template_input_input_16_listener($event) { i0.ɵɵrestoreView(_r100); const ctx_r101 = i0.ɵɵnextContext(); return ctx_r101.onNumberInputChange($event.target.value); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 17);
    i0.ɵɵelementStart(18, "div", 145);
    i0.ɵɵelementStart(19, "h6", 15);
    i0.ɵɵtext(20, "Due Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "p-calendar", 150);
    i0.ɵɵlistener("onSelect", function LibCreateInvoiceComponent_div_4_Template_p_calendar_onSelect_21_listener($event) { i0.ɵɵrestoreView(_r100); const ctx_r102 = i0.ɵɵnextContext(); return ctx_r102.dateChange($event, "invoiceDueDate"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "div", 17);
    i0.ɵɵelementStart(23, "div", 151);
    i0.ɵɵelementStart(24, "h6", 12);
    i0.ɵɵtext(25, "Generate Combined PDF (Invoice + Timesheet)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "div", 1);
    i0.ɵɵelement(27, "p-radioButton", 19);
    i0.ɵɵelement(28, "p-radioButton", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "div", 71);
    i0.ɵɵelementStart(30, "div", 76);
    i0.ɵɵelementStart(31, "h5", 77);
    i0.ɵɵtext(32, "Additional Documents");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(33, "div", 78);
    i0.ɵɵtemplate(34, LibCreateInvoiceComponent_div_4_div_34_Template, 7, 2, "div", 79);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(35, "div", 1);
    i0.ɵɵelementStart(36, "div", 17);
    i0.ɵɵelementStart(37, "div", 1);
    i0.ɵɵelementStart(38, "h6", 152);
    i0.ɵɵtext(39, "Would you like to send email reminder for the invoice");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(40, "div", 81);
    i0.ɵɵelement(41, "p-radioButton", 82);
    i0.ɵɵelement(42, "p-radioButton", 83);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(43, LibCreateInvoiceComponent_div_4_div_43_Template, 27, 11, "div", 84);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    let tmp_7_0 = null;
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("readonly", ctx_r1.isEditable);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("showIcon", true);
    i0.ɵɵadvance(10);
    i0.ɵɵproperty("showIcon", true)("disabled", ctx_r1.hasPaymentTerms);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction0(12, _c1))("value", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", false);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngForOf", (tmp_7_0 = ctx_r1.invoiceForm.get("termsAndConditionsDocs")) == null ? null : tmp_7_0.controls);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction0(13, _c1))("value", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.invoiceForm.controls["emailReminder"].value === true);
} }
class LibCreateInvoiceComponent {
    constructor(fb, cdr, createInvoiceService, customDropdownService, fbCustomDatePickerGroupService, CustomRadioButtonService, sanitizer, toasterService, uploadService, referenceLibraryService, dialogService, cRef, route, dialog) {
        this.fb = fb;
        this.cdr = cdr;
        this.createInvoiceService = createInvoiceService;
        this.customDropdownService = customDropdownService;
        this.fbCustomDatePickerGroupService = fbCustomDatePickerGroupService;
        this.CustomRadioButtonService = CustomRadioButtonService;
        this.sanitizer = sanitizer;
        this.toasterService = toasterService;
        this.uploadService = uploadService;
        this.referenceLibraryService = referenceLibraryService;
        this.dialogService = dialogService;
        this.cRef = cRef;
        this.route = route;
        this.dialog = dialog;
        this.subscription = [];
        this.observableSubscription$ = new Subject();
        this.minimumDate = new Date();
        this.others = false;
        this.clientsWithId = [];
        this.clientsWithoutId = [];
        this.grandTotal = 0;
        this.invoiceRadioValue = "Generate Invoice";
        this.invoicetempflag = false;
        this.invoicetempvalue = [];
        this.previewBillingItems = [];
        this.getFirmDetails = [];
        this.gettermsDetails = [];
        this.getTermsDocs = [];
        this.isEditable = true;
        this.isAttorneyFirmEditable = false;
        this.currencyOptions = [];
        this.listDocumentReferenceData = [];
        this.showReferenceCodeSection = false;
        this.displaypopup = false;
        this.selectedField = 0;
        this.documentTypeDropdownCode = "";
        this.hasPaymentTerms = false;
        this.storedGetTermsDocs = [];
        this.editIndex = null;
        this.disableAddButton = true;
        this.companyId = parseInt(sessionStorage.getItem("companyId"));
        this.uploadedFiles = [];
        this.listDocumentTypes = [];
        this.configurations = {
            disableControls: false,
            isDocumentTypeRequired: true,
            isDocumentUploadRequired: true,
            isViewEnabled: true,
            isDownloadEnabled: true,
            isDeleteEnabled: true,
            postApiUrl: "",
            getApiUrl: "",
            deleteApiUrl: "",
            documentTypeDropdownCode: "",
        };
        this.otherName = "";
    }
    ngOnInit() {
        var _a;
        this.userType = sessionStorage.getItem("userTypeRole");
        this.configurations.documentTypeDropdownCode = "OTHERDOCS";
        const selectedMenu = JSON.parse(sessionStorage.getItem("selectedMenu"));
        const menuId = ((_a = this.formBuilderInfo) === null || _a === void 0 ? void 0 : _a.menuId) || (selectedMenu === null || selectedMenu === void 0 ? void 0 : selectedMenu.value);
        if (menuId) {
            this.fileUploadConfigurations = {
                disableControls: false,
                isDocumentTypeRequired: true,
                isDocumentUploadRequired: true,
                isViewEnabled: true,
                isDownloadEnabled: true,
                isDeleteEnabled: true,
                getDocTypeApiUrl: `/referenceLibrary/${this.documentTypeDropdownCode}`,
                getApiUrl: `/vd/formBuilder/fetchAll/uploadedDocs/`,
                postApiUrl: `/vd/formBuilder/uploadDoc/formData/company/${this.companyId}/module/${this.formBuilderInfo.moduleId}/menu/${menuId}/form/${this.formBuilderInfo.id}?`,
                deleteApiUrl: `/vd/formBuilder/formDataDocs/delete/`,
                documentTypeDropdownCode: this.documentTypeDropdownCode,
                isFormBuilder: true,
                fbFormDataId: this.dataFormId
                    ? this.dataFormId
                    : "formDataId" in sessionStorage
                        ? parseInt(sessionStorage.getItem("formDataId"))
                        : null,
            };
            if (this.fileUploadConfigurations) {
                this.configurations = Object.assign({}, this.fileUploadConfigurations);
                this.dataFormId = this.configurations.fbFormDataId
                    ? this.configurations.fbFormDataId
                    : "";
                this.getDocuments();
            }
        }
        this.currentDate = new Date();
        this.group.addControl(this.inputParams.name, new FormGroup({
            selectedRadio: new FormControl(this.invoiceRadio),
            invoiceNumber: new FormControl(),
            paymentTerms: new FormControl(),
            invoiceDate: new FormControl(),
            invoiceDueDate: new FormControl(),
            invoiceDatetemp: new FormControl(),
            invoiceDueDatetemp: new FormControl(),
            emailReminder: new FormControl(false),
            generateCombinedPdf: new FormControl(true),
            reminderDate: new FormControl(),
            reminderTime: new FormControl(),
            invoiceId: new FormControl(),
            billedByCompany: new FormControl(),
            billedByEmail: new FormControl(),
            billedByPhoneCode: new FormControl(),
            billedByPhoneNumber: new FormControl(),
            billedByAddress: new FormControl(),
            billedByCountry: new FormControl(),
            billedByState: new FormControl(),
            billedByCity: new FormControl(),
            billedByPostCode: new FormControl(),
            billedToCompany: new FormControl(),
            billedToEmail: new FormControl(),
            billedToPhoneCode: new FormControl(),
            billedToPhoneNumber: new FormControl(),
            billedToAddress: new FormControl(),
            billedToCountry: new FormControl(),
            billedToState: new FormControl(),
            billedToCity: new FormControl(),
            billedToPostCode: new FormControl(),
            signature: new FormControl(),
            selectedCurrency: new FormControl(),
            selectedCurrencyType: new FormControl(),
            billingItemDTOs: this.fb.array([]),
            termsAndConditions: new FormArray([]),
            termsAndConditionsDocs: new FormArray([]),
            fileUploadown: new FormControl(),
            uploadedFile: new FormControl(),
            // dueDatereminderBef: new FormControl(false),
            // dueDatereminderOn: new FormControl(false),
            // dueDatereminderAft: new FormControl(false),
            gridEditorInputFields: this.fb.group({
                reminderDate: [''],
                reminderTime: [''],
                emailTemplates: [''],
                createdDate: [''],
                createdTime: [''],
            }),
            emailReminderFields: this.fb.array([]),
        }));
        this.invoiceForm = this.group.controls[this.inputParams.name];
        this.getInvoiceNo();
        this.getCurrencyCode();
        this.getBilledByDetails();
        this.getTermsAndConditions();
        this.loadDropdownData();
        this.grandTotal = this.createInvoiceService.getGrandTotal();
        const selectedCurrency = this.createInvoiceService.getSelectedCurrency();
        if (selectedCurrency) {
            this.group.controls[this.inputParams.name].patchValue({
                selectedCurrency: selectedCurrency
            });
            this.group.controls[this.inputParams.name].patchValue({
                selectedCurrency: selectedCurrency.id
            });
            this.selectedcurrencyicon = selectedCurrency.name.split(" ")[0];
            this.selectedCurrencyType = selectedCurrency.name.split("-")[1];
        }
        this.group.valueChanges.subscribe(() => {
            this.cdr.detectChanges();
        });
        this.group.controls[this.inputParams.name].patchValue({
            selectedRadio: this.invoiceRadio,
        });
        this.subscription[this.subscription.length] = this.createInvoiceService.getInvoicingbillingvaluetemp().subscribe((data) => {
            let billingarray = data.invoice;
            if (billingarray) {
                if ((billingarray === null || billingarray === void 0 ? void 0 : billingarray.length) > 0) {
                    this.invoiceForm.controls["billingItemDTOs"].clear();
                    billingarray.forEach((x) => {
                        this.billingItemDTOs = this.invoiceForm.get("billingItemDTOs");
                        this.billingItemDTOs.push(this.createBillingItem(x, 'edit'));
                    });
                }
                else {
                    this.invoiceForm.controls["billingItemDTOs"].clear();
                    this.addBillingItemDTOs('', 'create');
                }
            }
            else {
                this.invoiceForm.controls["billingItemDTOs"].clear();
                this.addBillingItemDTOs('', 'create');
            }
        });
        this.subscription[this.subscription.length] = this.createInvoiceService.gettempinvoiceflag().subscribe((data) => {
            this.invoicetempflag = data.invoice;
            if (this.invoicetempflag == true) {
                this.subscription[this.subscription.length] =
                    this.createInvoiceService.getInvoicingvaluetemp().subscribe((data) => {
                        this.invoicetempvalue = data.invoice;
                        if (this.invoicetempvalue.value.invoiceDate) {
                            let setDate = moment(new Date(this.invoicetempvalue.value.invoiceDate)).format("YYYY-MM-DD");
                            this.invoiceForm.controls['invoiceDate'].setValue(setDate);
                            this.invoiceForm.controls["invoiceDatetemp"].setValue(new Date(this.invoicetempvalue.value.invoiceDate));
                        }
                        if (this.invoicetempvalue.value.invoiceDueDate) {
                            let setDate = moment(new Date(this.invoicetempvalue.value.invoiceDueDate)).format("YYYY-MM-DD");
                            this.invoiceForm.controls['invoiceDueDate'].setValue(setDate);
                            this.invoiceForm.controls["invoiceDueDatetemp"].setValue(new Date(this.invoicetempvalue.value.invoiceDueDate));
                        }
                    });
            }
        });
        this.route.queryParams.subscribe(params => {
            const stepParameter = params['step'];
            if (!stepParameter) {
                this.invoiceForm.controls['invoiceDate'].setValue(null);
                this.invoiceForm.controls["invoiceDatetemp"].setValue(null);
                this.invoiceForm.controls['invoiceDueDate'].setValue(null);
                this.invoiceForm.controls["invoiceDueDatetemp"].setValue(null);
                this.customDropdownService.setPreviousEmails([]);
            }
        });
        this.subscription[this.subscription.length] =
            this.CustomRadioButtonService.getInvoicingRadioChange().subscribe((data) => {
                this.invoiceRadioValue = data.radio.name;
                this.invoiceRadio = data.radio;
                this.group.controls[this.inputParams.name].patchValue({
                    selectedRadio: this.invoiceRadio,
                });
                if (this.invoiceRadioValue != 'Generate Invoice') {
                    if (this.billingItemDTOs) {
                        this.billingItemDTOs.value.forEach((x, index) => {
                            this.billingItemDTOs.at(index).get("chargableAmount").clearValidators();
                            this.billingItemDTOs.at(index).get("chargableAmount").updateValueAndValidity();
                            this.billingItemDTOs.at(index).get("desc").clearValidators();
                            this.billingItemDTOs.at(index).get("desc").updateValueAndValidity();
                            this.billingItemDTOs.at(index).get("workingHours").clearValidators();
                            this.billingItemDTOs.at(index).get("workingHours").updateValueAndValidity();
                            this.billingItemDTOs.at(index).get("tax").clearValidators();
                            this.billingItemDTOs.at(index).get("tax").updateValueAndValidity();
                            this.billingItemDTOs.at(index).get("totalAmount").clearValidators();
                            this.billingItemDTOs.at(index).get("totalAmount").updateValueAndValidity();
                        });
                    }
                }
                else {
                    if (this.billingItemDTOs) {
                        this.billingItemDTOs.value.forEach((x, index) => {
                            this.billingItemDTOs.at(index).get("chargableAmount").setValidators([Validators.required, Validators.pattern(/^\d+(\.\d+)?$/), Validators.minLength(1), Validators.maxLength(15)]);
                            this.billingItemDTOs.at(index).get("chargableAmount").updateValueAndValidity();
                            this.billingItemDTOs.at(index).get("desc").setValidators([Validators.required, Validators.minLength(1), Validators.maxLength(200)]);
                            this.billingItemDTOs.at(index).get("desc").updateValueAndValidity();
                            this.billingItemDTOs.at(index).get("workingHours").setValidators([Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(1), Validators.maxLength(15)]);
                            this.billingItemDTOs.at(index).get("workingHours").updateValueAndValidity();
                            this.billingItemDTOs.at(index).get("tax").setValidators([Validators.pattern("^[0-9]*$"), Validators.minLength(1), Validators.maxLength(15)]);
                            this.billingItemDTOs.at(index).get("tax").updateValueAndValidity();
                            this.billingItemDTOs.at(index).get("totalAmount").setValidators([Validators.pattern(/^\d+(\.\d+)?$/), Validators.minLength(1), Validators.maxLength(15)]);
                            this.billingItemDTOs.at(index).get("totalAmount").updateValueAndValidity();
                        });
                    }
                }
            });
        this.subscription[this.subscription.length] = this.customDropdownService
            .getClientId()
            .subscribe((data) => {
            this.clientId = data.clientId;
            if (this.clientId) {
                this.getBilledToDetails();
            }
        });
        this.subscription[this.subscription.length] = this.customDropdownService
            .getProjectId()
            .subscribe((projectId) => {
            this.projectId = projectId;
        });
        this.subscription[this.subscription.length] = this.customDropdownService
            .getEmployeeId()
            .subscribe((employeeId) => {
            this.employeeId = employeeId;
        });
        this.subscription[this.subscription.length] = this.fbCustomDatePickerGroupService.getDates().subscribe(({ startDate, endDate }) => {
            this.startDate = startDate;
            this.endDate = endDate;
            if (this.startDate && this.endDate) {
                this.getBillingDetailsDto();
            }
        });
        this.route.queryParams.subscribe(params => {
            const stepParameter = params['step'];
            if (!stepParameter) {
                this.createInvoiceService.clearClientUploadedFiles();
                this.createInvoiceService.clearDurationUploadedFiles();
                const billingItemDTOsArray = this.invoiceForm.get('billingItemDTOs');
                billingItemDTOsArray.controls.forEach((item, index) => {
                    const currentItem = this.billingDetails ? this.billingDetails[index] : {};
                    item.get('desc').setValue(null);
                    item.get('chargableAmount').setValue(null);
                    item.get('workingHours').setValue(null);
                    item.get('tax').setValue(null);
                    item.get('totalAmount').setValue(0);
                });
                let grandTotal = 0;
                this.billingItemDTOs.value.forEach((x) => {
                    grandTotal += +x.totalAmount;
                });
                this.grandTotal = grandTotal;
            }
        });
        this.invoiceForm = (this.group.controls[this.inputParams.name]);
        this.group.valueChanges.subscribe(() => {
            this.cdr.detectChanges();
        });
    }
    getInvoiceNo() {
        this.createInvoiceService
            .getInvoiceNo()
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.getInvoiceNumber = response.data || null;
            this.invoiceForm.controls["invoiceNumber"].setValue(this.getInvoiceNumber);
        });
    }
    onNumberInputChange(num) {
        this.invoiceForm.controls['paymentTerms'].setValue(num);
        const invoiceDate = this.invoiceForm.controls['invoiceDatetemp'].value;
        this.invoiceForm.controls['invoiceDate'].setValue(invoiceDate);
        const paymentTerms = this.invoiceForm.controls['paymentTerms'].value;
        if (invoiceDate && paymentTerms) {
            this.hasPaymentTerms = true;
            const dueDate = moment(invoiceDate).add(paymentTerms, 'days').format('YYYY-MM-DD');
            this.dateChange(dueDate, 'invoiceDueDate');
        }
        else {
            this.hasPaymentTerms = false;
        }
    }
    getCurrencyCode() {
        this.createInvoiceService
            .getCurrencyCode()
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.currencyOptions = response.data || null;
            let type = this.currencyOptions[1];
            if (!this.group.controls[this.inputParams.name].get('selectedCurrencyType').value) {
                this.group.controls[this.inputParams.name].patchValue({
                    selectedCurrencyType: type,
                });
            }
            if (!this.group.controls[this.inputParams.name].get('selectedCurrency').value) {
                this.group.controls[this.inputParams.name].patchValue({
                    selectedCurrency: type.id,
                });
            }
            this.selectedcurrencyicon = !this.selectedcurrencyicon ? this.currencyOptions[1].name.split(" ")[0] : this.selectedcurrencyicon;
            this.selectedCurrencyType = !this.selectedCurrencyType ? this.currencyOptions[1].name.split("-")[1] : this.selectedCurrencyType;
        });
    }
    dateChange(date, controlName) {
        var _a;
        const paymentTerms = this.invoiceForm.controls['paymentTerms'].value;
        let setDate = moment(new Date(date)).format("YYYY-MM-DD");
        if (controlName === 'invoiceDate') {
            paymentTerms ? this.hasPaymentTerms = true : false;
            const dueDate = moment(setDate).add(paymentTerms, 'days').format('YYYY-MM-DD');
            this.invoiceForm.controls['invoiceDate'].setValue(date);
            this.invoiceForm.controls['invoiceDate'].updateValueAndValidity();
            this.invoiceForm.controls['invoiceDueDate'].setValue(dueDate);
            this.invoiceForm.controls['invoiceDueDate'].updateValueAndValidity();
        }
        else if (controlName === 'reminderDate') {
            const reminderDateFormatted = moment(date).format('MM/DD/YYYY');
            this.invoiceForm.controls['reminderDate'].setValue(reminderDateFormatted);
            (_a = this.invoiceForm.get('gridEditorInputFields.reminderDate')) === null || _a === void 0 ? void 0 : _a.setValue(reminderDateFormatted);
        }
        else {
            this.hasPaymentTerms = true;
            this.invoiceForm.controls['invoiceDueDate'].setValue(date);
        }
        this.createInvoiceService.sendInvoicingvaluetemp(this.invoiceForm);
        this.createInvoiceService.settempinvoiceflag(true);
    }
    getTimeStr(time) {
        const hour = time.getHours();
        const min = time.getMinutes();
        const amPm = hour >= 12 ? 'PM' : 'AM';
        const formattedHour = hour % 12 || 12;
        const formattedMin = min.toString().padStart(2, '0');
        return `${formattedHour}:${formattedMin} ${amPm}`;
    }
    timeChange(time, controlName) {
        var _a;
        if (controlName === 'reminderTime' && time) {
            const formattedTime = this.getTimeStr(time);
            this.invoiceForm.controls['reminderTime'].setValue(formattedTime);
            (_a = this.invoiceForm.get('gridEditorInputFields.reminderTime')) === null || _a === void 0 ? void 0 : _a.setValue(formattedTime);
        }
    }
    getBilledByDetails() {
        this.createInvoiceService
            .getBilledByDetails()
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            var _a;
            this.getFirmDetails = response.data || null;
            this.customDropdownService.setEmailsChanged(false);
            this.invoiceForm.controls["billedByCompany"].setValue(this.getFirmDetails.name);
            this.invoiceForm.controls["billedByEmail"].setValue(this.getFirmDetails.email);
            this.invoiceForm.controls["billedByPhoneCode"].setValue("+" + this.getFirmDetails.phone.phoneCode);
            this.invoiceForm.controls["billedByPhoneNumber"].setValue(this.getFirmDetails.phone.phoneNumber);
            this.invoiceForm.controls["billedByAddress"].setValue(this.getFirmDetails.address.addressLine1);
            this.invoiceForm.controls["billedByCountry"].setValue((_a = this.getFirmDetails.address.countryDetails) === null || _a === void 0 ? void 0 : _a.name);
            this.invoiceForm.controls["billedByState"].setValue(this.getFirmDetails.address.stateProvinceName);
            this.invoiceForm.controls["billedByCity"].setValue(this.getFirmDetails.address.city);
            this.invoiceForm.controls["billedByPostCode"].setValue(this.getFirmDetails.address.postCode);
            this.companyLogoImage = this.getFirmDetails.companyLogo
                ? "data:image/jpeg;base64," + this.getFirmDetails.companyLogo
                : null;
            this.invoiceForm.markAllAsTouched();
        });
    }
    arraysAreEqual(arr1, arr2) {
        if (arr1.length !== arr2.length) {
            return false;
        }
        for (let i = 0; i < arr1.length; i++) {
            if (arr1[i] !== arr2[i]) {
                return false;
            }
        }
        return true;
    }
    getBilledToDetails() {
        this.createInvoiceService
            .getBilledToDetails(this.clientId)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            var _a, _b, _c, _d, _e, _f, _g;
            this.getFirmDetails = response.data || null;
            this.createInvoiceService.clearClientUploadedFiles();
            const emails = ((_a = response.data) === null || _a === void 0 ? void 0 : _a.emails) || [];
            this.customDropdownService.sendEmails(emails);
            const previousEmails = this.customDropdownService.getPreviousEmails();
            const isEmailChanged = !this.arraysAreEqual(previousEmails, emails);
            this.customDropdownService.setEmailsChanged(isEmailChanged);
            this.customDropdownService.setPreviousEmails(emails);
            this.clientUploadedFiles = ((_b = response.data) === null || _b === void 0 ? void 0 : _b.uploadDocuments) || [];
            this.createInvoiceService.setClientUploadedFiles(response.data.uploadDocuments || []);
            this.getTermsAndConditions();
            if (this.getFirmDetails) {
                this.invoiceForm.controls["paymentTerms"].setValue(((_c = this.getFirmDetails) === null || _c === void 0 ? void 0 : _c.paymentTerms) ? this.getFirmDetails.paymentTerms : "");
                this.invoiceForm.controls["billedToCompany"].setValue(this.getFirmDetails.name);
                this.invoiceForm.controls["billedToEmail"].setValue(this.getFirmDetails.email);
                this.invoiceForm.controls["billedToPhoneCode"].setValue(this.getFirmDetails.phone.phoneCode ? "+" + this.getFirmDetails.phone.phoneCode : "");
                this.invoiceForm.controls["billedToPhoneNumber"].setValue(this.getFirmDetails.phone.phoneNumber);
                this.invoiceForm.controls["billedToAddress"].setValue(this.getFirmDetails.address.addressLine1);
                this.invoiceForm.controls["billedToCountry"].setValue(((_e = (_d = this.getFirmDetails.address) === null || _d === void 0 ? void 0 : _d.countryDetails) === null || _e === void 0 ? void 0 : _e.name) ? (_g = (_f = this.getFirmDetails.address) === null || _f === void 0 ? void 0 : _f.countryDetails) === null || _g === void 0 ? void 0 : _g.name : "");
                this.invoiceForm.controls["billedToState"].setValue(this.getFirmDetails.address.stateProvinceName);
                this.invoiceForm.controls["billedToCity"].setValue(this.getFirmDetails.address.city);
                this.invoiceForm.controls["billedToPostCode"].setValue(this.getFirmDetails.address.postCode);
                /* const invoiceDate = this.invoiceForm.controls['invoiceDatetemp'].value;
                this.dateChange(invoiceDate,"invoiceDate"); */
                this.invoiceForm.markAllAsTouched();
            }
        });
    }
    getBillingDetailsDto() {
        if (this.employeeId && this.projectId) {
            this.createInvoiceService
                .getBillingDetails(this.projectId, this.employeeId, this.startDate, this.endDate)
                .pipe(takeUntil(this.observableSubscription$))
                .subscribe((response) => {
                var _a, _b;
                this.billingDetails = ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.clientInvoiceDetails) || null;
                this.createInvoiceService.clearDurationUploadedFiles();
                this.durationUploadedFiles = ((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.uploadDocuments) || null;
                this.createInvoiceService.setDurationUploadedFiles(this.durationUploadedFiles || []);
                this.getTermsAndConditions();
                const billingItemDTOsArray = this.invoiceForm.get('billingItemDTOs');
                billingItemDTOsArray.clear();
                if (this.billingDetails) {
                    this.billingDetails.forEach((billingItem) => {
                        billingItemDTOsArray.push(this.fb.group({
                            desc: [billingItem.billingItem || null],
                            chargableAmount: [billingItem.chargeableAmt || null],
                            workingHours: [billingItem.hoursWorked || null],
                            tax: [billingItem.taxAmt || null],
                            totalAmount: [billingItem.totalAmt || null]
                        }));
                    });
                }
                let grandTotal = 0;
                this.billingItemDTOs.value.forEach((x) => {
                    grandTotal += +x.totalAmount;
                });
                this.grandTotal = grandTotal;
                this.createInvoiceService.setGrandTotal(grandTotal);
                this.createInvoiceService.sendInvoicingbillingvaluetemp(this.billingItemDTOs.value);
            });
        }
    }
    storedata() {
        this.createInvoiceService.sendInvoicingbillingvaluetemp(this.billingItemDTOs.value);
    }
    addBillingItemDTOs(item, mode) {
        this.billingItemDTOs = this.invoiceForm.get("billingItemDTOs");
        this.billingItemDTOs.push(this.createBillingItem(item, mode));
        this.createInvoiceService.sendInvoicingbillingvaluetemp(this.billingItemDTOs.value);
        this.invoiceForm.markAllAsTouched();
    }
    getTermsAndConditions() {
        this.invoiceForm.controls["termsAndConditions"].clear();
        this.invoiceForm.controls["termsAndConditionsDocs"].clear();
        this.createInvoiceService
            .getTermsDetails()
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            var _a, _b;
            this.gettermsDetails = ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.termsConditions) || null;
            this.getTermsDocs = ((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.uploadFiles) || null;
            this.route.queryParams.subscribe(params => {
                const stepParameter = params['step'];
                if (!stepParameter && !this.deleteDocCalled) {
                    this.storedGetTermsDocs = this.getTermsDocs;
                    this.createInvoiceService.setStoredGetTermsDocs(this.storedGetTermsDocs);
                }
                else {
                    this.storedGetTermsDocs = this.createInvoiceService.getStoredGetTermsDocs();
                }
            });
            let termsAndConditions = this.invoiceForm.get("termsAndConditions");
            let termsAndConditionsDocs = this.invoiceForm.get("termsAndConditionsDocs");
            let clientUploadedFiles = this.createInvoiceService.getClientUploadedFiles();
            let durationUploadedFiles = this.createInvoiceService.getDurationUploadedFiles();
            if (this.gettermsDetails || this.getTermsDocs) {
                this.gettermsDetails.forEach((item) => {
                    termsAndConditions.push(this.termscontent(item));
                });
                this.storedGetTermsDocs.forEach((item) => {
                    termsAndConditionsDocs.push(this.uploadFiles(item));
                });
            }
            clientUploadedFiles.forEach((file) => {
                termsAndConditionsDocs.push(this.uploadFiles(file));
            });
            durationUploadedFiles.forEach((file) => {
                termsAndConditionsDocs.push(this.uploadFiles(file));
            });
            this.deleteDocCalled = false;
        });
    }
    termscontent(data) {
        return this.fb.group({
            //term: [{disabled:true, value: data}],
            terms: [data],
        });
    }
    uploadFiles(data) {
        return this.fb.group({
            fileCategory: [data.fileCategory],
            fileSize: [data.fileSize],
            fileType: [data.fileType],
            fileUploadDate: [data.fileUploadDate],
            id: [data.id],
            fileName: [data.fileName],
            fileLocation: [data.fileLocation],
        });
    }
    createBillingItem(item, mode) {
        if (mode === 'edit') {
            return this.fb.group({
                chargableAmount: [
                    item.chargableAmount,
                    [Validators.required, Validators.pattern(/^\d+(\.\d+)?$/), Validators.minLength(1), Validators.maxLength(15)],
                ],
                desc: [item.desc, [Validators.required, Validators.minLength(1), Validators.maxLength(200)]],
                workingHours: [item.workingHours, [Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(1), Validators.maxLength(15)]],
                tax: [item.tax, [Validators.pattern("^[0-9]*$"), Validators.minLength(1), Validators.maxLength(15)]],
                totalAmount: [item.totalAmount, [Validators.pattern(/^\d+(\.\d+)?$/), Validators.minLength(1), Validators.maxLength(15)]],
            });
        }
        else {
            return this.fb.group({
                chargableAmount: [
                    '',
                    [Validators.required, Validators.pattern(/^\d+(\.\d+)?$/), Validators.minLength(1), Validators.maxLength(15)],
                ],
                desc: [null, [Validators.required, Validators.minLength(1), Validators.maxLength(200)]],
                workingHours: ['', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(1), Validators.maxLength(15)]],
                tax: ['', [Validators.pattern("^[0-9]*$"), Validators.minLength(1), Validators.maxLength(15)]],
                totalAmount: [0, [Validators.pattern(/^\d+(\.\d+)?$/), Validators.minLength(1), Validators.maxLength(15)]],
            });
        }
    }
    editTerms(i) {
        let termsAndConditions = this.invoiceForm.get("termsAndConditions");
        termsAndConditions.at(i).get("term").enable();
    }
    deleteTerms(i) {
        let termsAndConditions = this.invoiceForm.get("termsAndConditions");
        termsAndConditions.removeAt(i);
    }
    viewDoc(location) {
        let path;
        if (location.startsWith('/var/www')) {
            path = environment.appUrl + location.replace('var/www/', '');
        }
        else if (location.startsWith('/var/imagility/uploads')) {
            const port = ':5651';
            path = environment.appUrl + port + location.replace('/var/imagility/uploads', '/docs');
        }
        window.open(`${path}`, "_blank");
    }
    deleteDoc(i) {
        let termsAndConditionsDocs = this.invoiceForm.get("termsAndConditionsDocs");
        const deletedDoc = termsAndConditionsDocs.at(i).get('fileName').value;
        termsAndConditionsDocs.removeAt(i);
        const updatedClientUploadedFiles = this.createInvoiceService.getClientUploadedFiles().filter(file => file.fileName !== deletedDoc);
        const updatedDurationUploadedFiles = this.createInvoiceService.getDurationUploadedFiles().filter(file => file.fileName !== deletedDoc);
        if (this.storedGetTermsDocs !== null) {
            this.storedGetTermsDocs = this.storedGetTermsDocs.filter(file => file.fileName !== deletedDoc);
            this.createInvoiceService.setStoredGetTermsDocs(this.storedGetTermsDocs);
        }
        this.createInvoiceService.setClientUploadedFiles(updatedClientUploadedFiles);
        this.createInvoiceService.setDurationUploadedFiles(updatedDurationUploadedFiles);
        this.deleteDocCalled = true;
    }
    showTotal(item, index) {
        let total = 0;
        let tempTotal = 0;
        let calculateTax = 0;
        const currentChargableAmount = (item.controls.chargableAmount.value == "" || !item.controls.chargableAmount.value)
            ? Number(item.controls.chargableAmount.value)
            : parseFloat(item.controls.chargableAmount.value);
        const totalHours = (item.controls.workingHours.value == "" || !item.controls.workingHours.value)
            ? Number(item.controls.workingHours.value)
            : parseFloat(item.controls.workingHours.value);
        const currentTaxAmount = (item.controls.tax.value == "" || !item.controls.tax.value)
            ? Number(item.controls.tax.value)
            : parseFloat(item.controls.tax.value);
        if (this.selectedcurrencyicon == "₹") {
            //total = (currentChargableAmount * totalHours) + currentTaxAmount;
            tempTotal = currentChargableAmount * totalHours;
            calculateTax = tempTotal * (currentTaxAmount / 100);
            total = tempTotal + calculateTax;
            this.billingItemDTOs.at(index).get("totalAmount").setValue(total);
        }
        else {
            total = currentChargableAmount * totalHours;
            this.billingItemDTOs.at(index).get("totalAmount").setValue(total);
        }
        let grandTotal = 0;
        this.billingItemDTOs.value.forEach((x) => {
            grandTotal += +x.totalAmount;
        });
        this.grandTotal = grandTotal;
        this.createInvoiceService.setGrandTotal(grandTotal);
    }
    removeBillingItem(index) {
        this.billingItemDTOs.removeAt(index);
        let grandTotal = 0;
        this.billingItemDTOs.value.forEach((x) => {
            grandTotal += +x.totalAmount;
        });
        this.grandTotal = grandTotal;
    }
    convertCurrency(data) {
        let type = this.currencyOptions.filter((x) => x.id == data.value);
        this.group.controls[this.inputParams.name].patchValue({
            selectedCurrencyType: type,
        });
        this.group.controls[this.inputParams.name].patchValue({
            selectedCurrency: type[0].id,
        });
        this.selectedcurrencyicon = type[0].name.split(" ")[0];
        this.selectedCurrencyType = type[0].name.split("-")[1];
        this.createInvoiceService.setSelectedCurrency(type[0]);
        var billingItemDTOs = this.invoiceForm.get("billingItemDTOs");
        billingItemDTOs.controls.forEach((item, index) => {
            this.showTotal(item, index);
        });
    }
    numberToWords(number) {
        const units = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
        const teens = ['ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
        const tens = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
        if (number === 0) {
            return 'zero';
        }
        if (number < 0) {
            return 'minus ' + this.numberToWords(Math.abs(number));
        }
        let words = '';
        if (Math.floor(number / 1000000) > 0) {
            words += this.numberToWords(Math.floor(number / 1000000)) + ' million ';
            number %= 1000000;
        }
        if (Math.floor(number / 1000) > 0) {
            words += this.numberToWords(Math.floor(number / 1000)) + ' thousand ';
            number %= 1000;
        }
        if (Math.floor(number / 100) > 0) {
            words += this.numberToWords(Math.floor(number / 100)) + ' hundred ';
            number %= 100;
        }
        if (number > 0) {
            if (words !== '') {
                words += 'and ';
            }
            if (number < 10) {
                words += units[number];
            }
            else if (number < 20) {
                words += teens[number - 10];
            }
            else {
                words += tens[Math.floor(number / 10)];
                if ((number % 10) > 0) {
                    words += '-' + units[number % 10];
                }
            }
        }
        return words.trim();
    }
    numberToWordsWithDecimals(number) {
        const numberParts = number.toString().split('.');
        const integerPart = parseInt(numberParts[0]);
        let fractionalPart = '';
        if (numberParts.length > 1) {
            fractionalPart = numberParts[1];
        }
        let words = this.numberToWords(integerPart);
        if (fractionalPart !== '') {
            words += ' point ';
            for (let i = 0; i < fractionalPart.length; i++) {
                const digit = parseInt(fractionalPart[i]);
                words += this.numberToWords(digit) + ' ';
            }
        }
        return words;
    }
    onUploadHandle(event, fubauto) {
        const file = event.files[0];
        this.group.controls[this.inputParams.name].patchValue({
            uploadedFile: event.files[0],
        });
        file.fileName = event.files[0].name;
        const payload = new FormData();
        payload.append("file", file, file.name);
        let apiUrl;
        this.configurations.documentTypeDropdownCode = "OTHERDOCS";
        apiUrl =
            `${this.configurations.postApiUrl}` +
                `${this.configurations.documentTypeDropdownCode
                    ? "documentCategory=" + this.configurations.documentTypeDropdownCode
                    : ""}` +
                `${this.dataFormId ? "&formDataId=" + this.dataFormId : ""}`;
        this.uploadService
            .uploadDocument(apiUrl, payload)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.toasterService.success(response.message, 'Success');
            this.cRef.detectChanges();
            this.otherName = "";
            if (this.configurations.isFormBuilder) {
                this.dataFormId = response.data ? response.data.formDataId : "";
                this.createInvoiceService.formDataIdChanges.next({
                    dataFormId: this.dataFormId,
                });
            }
            this.getDocuments();
            if (this.configurations.isDocumentTypeRequired) {
                this.configurations.documentTypeDropdownCode = "";
            }
            fubauto.clear();
        });
    }
    getDocuments() {
        if (this.configurations.getApiUrl &&
            (!this.configurations.isFormBuilder ||
                (this.configurations.isFormBuilder && this.dataFormId))) {
            let apiUrl = this.configurations.getApiUrl;
            if (this.configurations.familyId) {
                apiUrl = `${this.configurations.getApiUrl}?familyId=${this.configurations.familyId}`;
            }
            if (this.configurations.isFormBuilder) {
                apiUrl = `${apiUrl}` + `${this.dataFormId}`;
            }
            this.uploadService
                .getUploadedDocument(apiUrl)
                .pipe(takeUntil(this.observableSubscription$))
                .subscribe((response) => {
                this.uploadedFiles = Object.assign([], response.data);
                this.group.controls[this.inputParams.name].patchValue({
                    fileUploadown: response.data[0].id,
                });
            });
        }
    }
    deleteDocumentTypeLis(input) {
        const deleteDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, DeleteDialogConfigurations);
        deleteDialogRef.onClose
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response) {
                this.uploadService
                    .deleteUploadDocument(this.configurations.deleteApiUrl + `${input.id}`)
                    .pipe(takeUntil(this.observableSubscription$))
                    .subscribe((responseUploadedDocs) => {
                    this.toasterService.success(responseUploadedDocs.message, 'Success');
                    this.getDocuments();
                });
            }
        });
    }
    openDoc(item) {
        if (this.configurations.isFormBuilder) {
            const docPath = item.fileLocation;
            window.open(`${environment.appUrl}${docPath}`, "_blank");
        }
        else {
            const docPath = item.fileLocation.substring(23);
            window.open(`${environment.docs}${docPath}`, "_blank");
        }
    }
    download(file) {
        if (this.configurations.isFormBuilder) {
            this.uploadService.downloadDocuments(environment.appUrl + file.fileLocation, file.fileLocation);
        }
        else {
            this.uploadService.downloadDocuments(environment.docs + file.fileLocation.substring(23), file.fileLocation.substring(23));
        }
    }
    get emailReminderFields() {
        return this.invoiceForm.get('emailReminderFields');
    }
    get gridEditorInputFields() {
        return this.invoiceForm.get('gridEditorInputFields');
    }
    get isemailReminderFieldsEmpty() {
        var _a;
        return ((_a = this.emailReminderFields) === null || _a === void 0 ? void 0 : _a.length) === 0;
    }
    loadDropdownData() {
        combineLatest([
            this.createInvoiceService.getDataSourceList('FB_HR__INV_TEMPLATE_BUILDER'),
        ])
            .pipe(take$1(1))
            .subscribe((response) => {
            this.emailTemplates = response[0];
        });
    }
    isAddButtonEnabled() {
        const { reminderDate, reminderTime, emailTemplates } = this.gridEditorInputFields.value;
        return !!(reminderDate && reminderTime && emailTemplates);
    }
    updateHtmlRenderObj() {
        const keys = Object.keys(this.group.value);
        keys.forEach(key => {
            const htmlRenderObjIndex = this.getHtmlRenderObjIndex(key);
            if (htmlRenderObjIndex > -1) {
                const columnObj = this.htmlRenderObj[htmlRenderObjIndex];
                const layoutCode = columnObj === null || columnObj === void 0 ? void 0 : columnObj.layoutCode;
                const value = this.group.value[key];
                switch (layoutCode) {
                    case 'CustomGridEditor':
                        columnObj.gridValues = value.gridValues;
                        break;
                    case 'VdSwitchGroupComponent':
                        this.updateSwitchGroupValue(columnObj, value);
                        break;
                    case 'CustomQuestionsGroupComponent':
                        columnObj.questionCheck = value;
                        columnObj.value = value;
                        break;
                    case 'CustomCalenderComponent':
                        columnObj.value = value || '';
                        break;
                    case 'LibTemplateViewer':
                        if (columnObj.groupName === 'TEMPLATE_VIEWER_m50m798d7ymqrnb7dpf') {
                            columnObj.value = {
                                emailTo: value.emailTo || [],
                                emailCC: value.emailCC || [],
                                emailSubject: value.emailSubject || '',
                                emailTemplateContent: value.emailTemplateContent || '',
                                templateId: value.templateId || ''
                            };
                        }
                        break;
                    default:
                        columnObj.value = value;
                        break;
                }
            }
        });
    }
    getHtmlRenderObjIndex(key) {
        const findIndexCondition = x => ['VdEadLibraryComponent', 'VdCountryStateComponent'].includes(x.layoutCode)
            ? x.groupName === key
            : x.name === key;
        return this.htmlRenderObj.findIndex(findIndexCondition);
    }
    updateSwitchGroupValue(columnObj, value) {
        const switchGridProps = columnObj.groupElementProperty;
        let additionalInfo = '';
        if ((switchGridProps === null || switchGridProps === void 0 ? void 0 : switchGridProps.whenTextAreaShown) === 'off') {
            additionalInfo = value.switch_field === true ? '' : value.additional_info_for_switch_field;
        }
        else if ((switchGridProps === null || switchGridProps === void 0 ? void 0 : switchGridProps.whenTextAreaShown) === 'on') {
            additionalInfo = value.switch_field === false ? '' : value.additional_info_for_switch_field;
        }
        else {
            additionalInfo = value.additional_info_for_switch_field;
        }
        columnObj.value = {
            switch_field: value.switch_field,
            additional_info_for_switch_field: additionalInfo
        };
        columnObj.questionCheck = value.switch_field;
    }
    createPayload() {
        const payload = {};
        payload.companyId = 'companyId' in sessionStorage ? parseInt(sessionStorage.getItem('companyId')) : null;
        const formDateJsonPayload = this.htmlRenderObj;
        payload.formDateJson = JSON.stringify(formDateJsonPayload);
        return payload;
    }
    openTemplatePreview(index) {
        console.log(index, 'rowIndex');
        this.updateHtmlRenderObj();
        const payload = this.createPayload();
        this.formData = JSON.parse(payload.formDateJson);
        console.log(this.formData, 'formData payload');
        const row = this.emailReminderFields.at(index).value;
        const templateName = row.emailTemplates;
        const matchingTemplate = this.emailTemplates.find(template => template.name === templateName);
        if (matchingTemplate) {
            const matchingId = matchingTemplate.id;
            this.createInvoiceService.getInvoicePreviewDetails(matchingId, this.formData).subscribe(data => {
                if (data) {
                    // this.emailContent = data.emailBody;
                    this.dialog.open(TemplatePreviewDialog, {
                        width: '900px',
                        height: '500px',
                        data: { content: data.emailBody },
                    });
                }
            });
            // this.createInvoiceService.getInvTemplateDetails(matchingId).pipe(takeUntil(this.observableSubscription$)).subscribe(response => {
            //   if (response.status === 200) {
            //     this.templateDetails = response.data;
            //     this.dialog.open(TemplatePreviewDialog, {
            //       width: '900px',
            //       height: '500px',
            //       data: { content: this.templateDetails.emailTemplateContent },
            //     });
            //   }
            // });
        }
    }
    addGridEditorField() {
        var _a, _b, _c, _d, _e;
        const currentDate = moment().format('MM/DD/YYYY');
        const currentTime = moment().format('hh:mm A');
        const newRow = this.fb.group({
            reminderDate: (_a = this.gridEditorInputFields.get('reminderDate')) === null || _a === void 0 ? void 0 : _a.value,
            reminderTime: (_b = this.gridEditorInputFields.get('reminderTime')) === null || _b === void 0 ? void 0 : _b.value,
            emailTemplates: (_c = this.gridEditorInputFields.get('emailTemplates')) === null || _c === void 0 ? void 0 : _c.value,
            createdDate: this.editIndex !== null
                ? (_d = this.emailReminderFields.at(this.editIndex).get('createdDate')) === null || _d === void 0 ? void 0 : _d.value : currentDate,
            createdTime: this.editIndex !== null
                ? (_e = this.emailReminderFields.at(this.editIndex).get('createdTime')) === null || _e === void 0 ? void 0 : _e.value : currentTime,
        });
        // this.emailReminderFields.push(newRow);
        if (this.editIndex !== null) {
            this.emailReminderFields.setControl(this.editIndex, newRow);
            this.toasterService.success("Reminder updated successfully", 'Success');
            this.editIndex = null;
        }
        else {
            this.emailReminderFields.push(newRow);
            this.toasterService.success("Reminder Added successfully", 'Success');
        }
        this.gridEditorInputFields.reset();
    }
    onEdit(index) {
        const row = this.emailReminderFields.at(index);
        this.gridEditorInputFields.patchValue(row.value);
        this.editIndex = index;
    }
    onDelete(index) {
        this.emailReminderFields.removeAt(index);
        this.toasterService.success("Reminder deleted successfully", 'Success');
    }
    onReset() {
        this.gridEditorInputFields.reset();
        // if (this.editIndex !== null) {
        //   this.emailReminderFields.at(this.editIndex).reset();
        //   this.editIndex = null;
        // } else {
        //   this.emailReminderFields.clear();
        // }
    }
    dueDateReminderSwitch(controlName, value) {
        var _a;
        const control = (_a = this.group.get(this.inputParams.name)) === null || _a === void 0 ? void 0 : _a.get(controlName);
        if (control) {
            control.setValue(value);
        }
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
        this.subscription.forEach(sub => sub.unsubscribe());
    }
}
LibCreateInvoiceComponent.ɵfac = function LibCreateInvoiceComponent_Factory(t) { return new (t || LibCreateInvoiceComponent)(i0.ɵɵdirectiveInject(i1$2.FormBuilder), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(LibCreateInvoiceService), i0.ɵɵdirectiveInject(i3.CustomDropdownService), i0.ɵɵdirectiveInject(i4.FbCustomDatePickerGroupService), i0.ɵɵdirectiveInject(i5.CustomRadioButtonService), i0.ɵɵdirectiveInject(i6.DomSanitizer), i0.ɵɵdirectiveInject(i7.ToastrService), i0.ɵɵdirectiveInject(i8.FileUploadLibraryService), i0.ɵɵdirectiveInject(i9.ReferenceLibraryService), i0.ɵɵdirectiveInject(i10.DialogService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i11.ActivatedRoute), i0.ɵɵdirectiveInject(i1$1.MatDialog)); };
LibCreateInvoiceComponent.ɵcmp = i0.ɵɵdefineComponent({ type: LibCreateInvoiceComponent, selectors: [["lib-create-invoice"]], inputs: { htmlRenderObj: "htmlRenderObj", group: "group", inputParams: "inputParams", formBuilderInfo: "formBuilderInfo" }, decls: 5, vars: 3, consts: [[1, "row", "create-invoice"], [1, "col-12"], [3, "formGroup"], [4, "ngIf"], ["class", "row", 4, "ngIf"], [1, "row"], [1, "col-6"], ["alt", "company-logo", 1, "companyLogoImage", 3, "src"], [1, "col-12", "col-lg-12", "text-right"], [1, "d-inline-block", "w-800"], ["type", "text", "formControlName", "invoiceNumber", 1, "invoice_number", "p-0", 3, "readonly"], [1, "row", "mt-2"], [1, "d-inline-block", "w-800", "pr-3"], ["id", "invoiceDate", "yearRange", "1900:2100", "appendTo", "body", "type", "text", "formControlName", "invoiceDatetemp", "yearNavigator", "true", "monthNavigator", "true", "inputId", "icon", "placeholder", "MM-DD-YYYY", "dateFormat", "mm/dd/yy", "name", "invoiceDate", 1, "im-input-calendar", 3, "showIcon", "onSelect"], [1, "input-container"], [1, "d-inline-block", "w-800", "col-3", "p-0"], ["type", "number", "aria-label", "inputParams?.label", "formControlName", "paymentTerms", 1, "form-control", 2, "width", "50%", "position", "relative", "left", "6px", 3, "input"], [1, "row", "mt-3"], ["id", "invoiceDueDate", "yearRange", "1900:2100", "appendTo", "body", "formControlName", "invoiceDueDatetemp", "type", "text", "yearNavigator", "true", "monthNavigator", "true", "inputId", "icon", "placeholder", "MM-DD-YYYY", "dateFormat", "mm/dd/yy", "name", "invoiceDueDate", 1, "im-input-calendar", 3, "showIcon", "disabled", "onSelect"], ["name", "generateCombinedPdf", "formControlName", "generateCombinedPdf", "label", "Yes", 3, "ngStyle", "value"], ["name", "generateCombinedPdf", "formControlName", "generateCombinedPdf", "label", "No", 3, "value"], [1, "row", "invoice-form-container", "pb-3", "mt-4"], [1, "col-12", "p-2", "pl-3"], [1, "col-5", "invoice-form-container", "ml-4", "mr-5"], [1, "row", "p-2"], [1, "label-cls", "mb-2"], ["type", "text", "formControlName", "billedByCompany", 1, "ml-0", 3, "readonly"], ["for", "", 1, "item-label"], ["type", "text", "formControlName", "billedByEmail", 1, "ml-0", 3, "readonly"], [1, "d-flex"], ["type", "text", "formControlName", "billedByPhoneCode", 1, "col-md-3", "ml-0", 3, "readonly"], ["type", "number", "formControlName", "billedByPhoneNumber", 1, "pr-1", 3, "readonly"], ["type", "text", "formControlName", "billedByAddress", 1, "ml-0", 3, "readonly"], ["type", "text", "formControlName", "billedByCountry", 1, "ml-0", 3, "readonly"], ["type", "text", "formControlName", "billedByState", 1, "ml-0", 3, "readonly"], [1, "row", "mt-3", "mb-2"], ["type", "text", "formControlName", "billedByCity", 1, "ml-0", 3, "readonly"], ["type", "number", "formControlName", "billedByPostCode", 1, "ml-0", 3, "readonly"], [1, "col-5", "invoice-form-container", "ml-5", "mr-0"], ["type", "text", "formControlName", "billedToCompany", 3, "readonly"], ["type", "text", "formControlName", "billedToEmail", 3, "readonly"], ["type", "text", "formControlName", "billedToPhoneCode", 1, "col-md-3", "ml-0", 3, "readonly"], ["type", "text", "formControlName", "billedToPhoneNumber", 1, "", 3, "readonly"], ["type", "text", "formControlName", "billedToAddress", 3, "readonly"], ["type", "text", "formControlName", "billedToCountry", 3, "readonly"], ["type", "text", "formControlName", "billedToState", 3, "readonly"], ["type", "text", "formControlName", "billedToCity", 3, "readonly"], ["type", "number", "formControlName", "billedToPostCode", 3, "readonly"], [1, "row", "invoice-form-container", "p-3", "mt-4"], [1, "col-3", "p-2"], ["formControlName", "selectedCurrency", "appendTo", "body", "optionLabel", "name", "optionValue", "id", 1, "w-100", 3, "options", "onChange"], ["pTemplate", "item"], [1, "col-12", "p-2"], [1, "mt-2", "ml-2"], [1, "row", "billing-item", "p-2", 2, "width", "100% !important"], [1, "col-3", "col-lg-3", "bill-item"], [1, "col-3", "col-lg-2", "bill-item"], [1, "col-2", "col-lg-2", "bill-item"], ["class", "col-2 col-lg-2 bill-item", 4, "ngIf"], [1, "col-1", "col-lg-2", "bill-item"], ["formArrayName", "billingItemDTOs", 1, "pt-4", "d-block", "array_container"], [4, "ngFor", "ngForOf"], [1, "col-12", "text-center"], ["type", "button", 1, "new-row", 3, "disabled", "click"], [1, "row", "d-block", "mt-3"], [1, "col-6", "pull-right", "d-block", "mt-3"], [1, "col-6", "pr-3", "mr-2"], [1, "total"], [1, "total-amount", "col-6", "text-center"], ["name", "isSameAddress", "binary", "true", "label", "Show total in words", 1, "show-words"], ["checkbox1", ""], [1, "row", "invoice-form-container", "mt-3", "mb-2"], [1, "terms", "col-10", "p-2", "pl-3"], [1, "terms", "col-2", "p-2", "pl-3"], ["formArrayName", "termsAndConditions", 1, "col-12", "m-2"], ["class", "row", 4, "ngFor", "ngForOf"], [1, "col-12", "p-0", "w-600"], [1, "p-3"], [1, "col-12", "p-0"], ["class", "row", "formArrayName", "termsAndConditionsDocs", 4, "ngFor", "ngForOf"], [1, "col-12", "reminder-layout"], [1, "col-12", "grid-fields"], ["name", "emailReminder", "formControlName", "emailReminder", "label", "Yes", 3, "ngStyle", "value"], ["name", "emailReminder", "formControlName", "emailReminder", "label", "No", 3, "value"], ["class", "row mt-3", 4, "ngIf"], [1, "ui-helper-clearfix"], [1, "currency_label"], [1, "mb-3", 3, "formGroupName"], [1, "row", "nopadding"], [1, "col-3"], ["type", "text", "placeholder", "Enter resource Name", "formControlName", "desc", 1, "m-0", 3, "change"], ["class", "p-error", 4, "ngIf"], [1, "col-2"], [1, "p-input-icon-left"], [1, "icon-style"], ["pInputText", "", "pKeyFilter", "int", "formControlName", "chargableAmount", "placeholder", "Enter Amount", 3, "min", "max", "change", "keyup"], [1, "clock"], ["src", "../../../../assets/images/admin_reports_icons/schedule.png", 1, ""], ["pInputText", "", "pKeyFilter", "int", "pInputText", "", "formControlName", "workingHours", "placeholder", "Hours", 1, "workHours", 3, "change", "keyup"], ["class", "col-2", 4, "ngIf"], ["pInputText", "", "pKeyFilter", "int", "formControlName", "totalAmount", "placeholder", "Total Amount", 3, "readonly"], ["class", "col-1", 4, "ngIf"], [1, "p-error"], ["pInputText", "", "pKeyFilter", "int", "formControlName", "tax", "placeholder", "Enter Tax As % Value", 3, "change", "keyup"], [1, "col-1"], [1, ""], ["mat-stroked-button", "", 1, "remove-billing-item", 3, "click"], [1, "remove_icon"], [1, "text-capitalize"], [1, "col-10", "pb-2", "pl-0", "terms_content", 3, "formGroupName"], [1, "p-0", "pt-2"], ["type", "text", "formControlName", "terms", 1, "terms_content", "ml-2", 3, "readonly"], [1, "action_items", "col-2", "pl-0"], [1, "mr-2", "padding0", "d-inline-block"], ["pButton", "", "type", "button", "icon", "pi pi-pencil", "pTooltip", "Edit", 1, "p-button-text", "p-button-rounded", 3, "click"], ["pButton", "", "type", "button", "icon", "pi pi-trash", "pTooltip", "Delete", 1, "p-button-text", "p-button-rounded", 3, "click"], ["formArrayName", "termsAndConditionsDocs", 1, "row"], [1, "col-10", 3, "formGroupName"], [1, "col-2", "text-right"], ["pButton", "", "type", "button", "icon", "pi pi-eye", "pTooltip", "View", 1, "p-button-text", "p-button-rounded", 3, "click"], [1, "row", "mt-2", "dotted-line"], ["formGroupName", "gridEditorInputFields", 1, "row", "col-12", "mb-3", "grid-fields"], [1, "col-8"], [1, "row", "calender-field"], [1, "col-7", "pr-1"], ["id", "reminderDate", "yearRange", "1900:2100", "appendTo", "body", "type", "text", "formControlName", "reminderDate", "yearNavigator", "true", "monthNavigator", "true", "inputId", "icon", "placeholder", "MM-DD-YYYY", "dateFormat", "mm/dd/yy", "name", "reminderDate", 1, "im-input-calendar", 3, "showIcon", "minDate", "onSelect"], [1, "col-5", "pl-1"], ["timeOnly", "true", "showTime", "true", "hourFormat", "12", "id", "reminderTime", "appendTo", "body", "formControlName", "reminderTime", "inputId", "icon", "dateFormat", "mm/dd/yy", "placeholder", "HH:MM", "name", "reminderTime", 1, "im-input-calendar", 3, "showIcon", "disabled", "icon", "onSelect"], [1, "col-4"], [1, "col", "mb-2"], ["formControlName", "emailTemplates", "optionLabel", "name", "optionValue", "name", "placeholder", "Select Template", 3, "options"], [1, "col-12", "mb-3"], ["type", "button", 1, "btn", "btn-primary", "mr-2", 3, "disabled", "click"], ["type", "button", 1, "btn", "btn-secondary", 3, "click"], ["styleClass", "vdFileUploadTable", 3, "value"], ["pTemplate", "header"], ["pTemplate", "body"], ["pTemplate", "emptymessage"], [2, "text-align", "center"], [1, "buttons-holder"], ["type", "button", "pButton", "", "icon", "pi pi-eye", "pTooltip", "View", 1, "p-button-text", "p-button-rounded", 3, "click"], ["type", "button", "title", "Edit", "pTooltip", "Edit", "pButton", "", "icon", "pi pi-pencil", 1, "p-button-text", "p-button-rounded", 3, "click"], ["type", "button", "title", "Delete", "pTooltip", "Delete", "pButton", "", "icon", "pi pi-trash", 1, "p-button-text", "p-button-rounded", 3, "click"], ["colspan", "6"], [1, "visa-row-nodata"], [1, "col-6", "col-lg-6"], ["type", "text", "formControlName", "invoiceNumber", 1, "invoice_number", "p-0", "col-9", 3, "readonly"], ["id", "invoiceDate", "yearRange", "1900:2100", "appendTo", "body", "formControlName", "invoiceDatetemp", "type", "text", "yearNavigator", "true", "monthNavigator", "true", "showIcon", "true", "inputId", "icon", "placeholder", "MM-DD-YYYY", "dateFormat", "mm/dd/yy", "name", "invoiceDate", 1, "im-input-calendar", "col-9", 3, "showIcon", "onSelect"], [1, "d-inline-block", "w-800", "col-3", "p-0", "mr-2"], ["type", "number", "aria-label", "inputParams?.label", "formControlName", "paymentTerms", 1, "form-control", "d-inline-block", 2, "width", "50%", 3, "input"], ["id", "invoiceDueDate", "yearRange", "1900:2100", "appendTo", "body", "formControlName", "invoiceDueDatetemp", "type", "text", "yearNavigator", "true", "monthNavigator", "true", "inputId", "icon", "placeholder", "MM-DD-YYYY", "dateFormat", "mm/dd/yy", "name", "invoiceDueDate", 1, "im-input-calendar", "col-9", 3, "showIcon", "disabled", "onSelect"], [1, "col-12", "col-lg-12"], [1, "d-inline-block", "w-800", "pr-3", "owninv-reminder-label"]], template: function LibCreateInvoiceComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "form", 2);
        i0.ɵɵtemplate(3, LibCreateInvoiceComponent_div_3_Template, 189, 41, "div", 3);
        i0.ɵɵtemplate(4, LibCreateInvoiceComponent_div_4_Template, 44, 14, "div", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("formGroup", ctx.invoiceForm);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.invoiceRadioValue == "Generate Invoice");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.invoiceRadioValue != "Generate Invoice");
    } }, directives: [i1$2.ɵangular_packages_forms_forms_ba, i1$2.NgControlStatusGroup, i1$2.FormGroupDirective, i13.NgIf, i1$2.DefaultValueAccessor, i1$2.NgControlStatus, i1$2.FormControlName, i14.Calendar, i1$2.NumberValueAccessor, i15.RadioButton, i13.NgStyle, i16.Dropdown, i17.PrimeTemplate, i1$2.FormArrayName, i13.NgForOf, i18.Checkbox, i1$2.FormGroupName, i19.InputText, i20.MatButton, i21.MatIcon, i22.ButtonDirective, i23.Tooltip, i24.Table], styles: [".invoice-form-container[_ngcontent-%COMP%]{border:2px dashed #758db5}.header_bg[_ngcontent-%COMP%], .invoice-form-container[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{background:#edf4fb}.label-cls[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{font-weight:600}.companyLogoImage[_ngcontent-%COMP%]{width:170px;height:65px}.nopadding[_ngcontent-%COMP%]{padding:0!important;margin:0!important}table[_ngcontent-%COMP%]{border-collapse:collapse;width:100%;font:normal normal 700 16px Source Sans Pro;letter-spacing:0;color:#505050;opacity:1}table[_ngcontent-%COMP%], td[_ngcontent-%COMP%], th[_ngcontent-%COMP%]{text-align:left}td[_ngcontent-%COMP%], th[_ngcontent-%COMP%]{border:1px solid #ddd;padding:8px}td[_ngcontent-%COMP%]{font-size:14px;font-weight:400}.w-100[_ngcontent-%COMP%]{width:100%!important}.billing-item[_ngcontent-%COMP%]{background-color:#edf4fb!important;border:1px solid #707070;border-bottom:none}.array_container[_ngcontent-%COMP%]{border:1px solid #707070}.item-label[_ngcontent-%COMP%]{font:normal normal normal 14px/20px Source Sans Pro;color:#4a4a4a}.bill-item[_ngcontent-%COMP%]{font:normal normal 600 16px/22px Source Sans Pro}.bill-item[_ngcontent-%COMP%], .terms[_ngcontent-%COMP%]{letter-spacing:0;color:#606060;opacity:1}.terms[_ngcontent-%COMP%]{font:normal normal 700 20px Source Sans Pro}.new-row[_ngcontent-%COMP%]{font:normal normal normal 16px/22px Source Sans Pro;letter-spacing:0;color:#01a0da;z-index:3;border:none;background:none}.p-input-icon-left[_ngcontent-%COMP%] > i[_ngcontent-%COMP%]:first-of-type{left:0;color:#6c757d}.p-input-icon-left[_ngcontent-%COMP%] > i[_ngcontent-%COMP%], .p-input-icon-right[_ngcontent-%COMP%] > i[_ngcontent-%COMP%]{position:absolute;top:0;margin-top:0}.icon-style[_ngcontent-%COMP%]{background:#efefef;position:absolute;top:0;bottom:0;height:40px;width:25px;display:inline-block;padding:8px}.text[_ngcontent-%COMP%]{text-align:left;font:normal normal 700 54px/54px Source Sans Pro;letter-spacing:0;color:#505050;opacity:1;font-weight:700}.divider[_ngcontent-%COMP%]{border:none;border-top:1px solid #d3d3d3;color:#fff;background-color:#fff;height:1px;width:100%}.total[_ngcontent-%COMP%]{letter-spacing:0;color:#606060}.total[_ngcontent-%COMP%], .total-amount[_ngcontent-%COMP%]{font:normal normal 700 20px Source Sans Pro}.total-amount[_ngcontent-%COMP%]{color:#01a0da}.show-words[_ngcontent-%COMP%]{color:#4d4f5c}.p-checkbox-label[_ngcontent-%COMP%]{color:#4d4f5c!important}.invoice_number[_ngcontent-%COMP%]{border:none!important;background:transparent!important;display:inline-block;width:30%;text-align:right}.lang-change-img[_ngcontent-%COMP%]{height:30px;width:30px}.clock[_ngcontent-%COMP%]{position:absolute;display:inline-block;background:#efefef;height:auto;overflow:hidden;top:0;padding:8px 5px}.clock[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:20px;width:20px}.ui-helper-clearfix[_ngcontent-%COMP%]{position:relative;height:25px}.currency_label[_ngcontent-%COMP%]{font-size:14px;display:inline-block;margin-top:4px;padding-left:20px}.terms_content[_ngcontent-%COMP%]{display:inline-block;width:96%}.input-container[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:flex-end}.reminder-switches[_ngcontent-%COMP%]{margin-top:18px;margin-left:42px}.reminder-label[_ngcontent-%COMP%]{font-weight:600;flex:1;text-align:left;margin:0}.calender-field[_ngcontent-%COMP%], .grid-fields[_ngcontent-%COMP%]{margin-left:-16px}.reminder-layout[_ngcontent-%COMP%]{margin-left:-28px}.buttons-holder[_ngcontent-%COMP%]{float:left;margin-left:-32px}.owninv-reminder-label[_ngcontent-%COMP%]{margin-left:-14px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibCreateInvoiceComponent, [{
        type: Component,
        args: [{
                selector: "lib-create-invoice",
                templateUrl: "./lib-create-invoice.component.html",
                styleUrls: ["./lib-create-invoice.component.scss"],
            }]
    }], function () { return [{ type: i1$2.FormBuilder }, { type: i0.ChangeDetectorRef }, { type: LibCreateInvoiceService }, { type: i3.CustomDropdownService }, { type: i4.FbCustomDatePickerGroupService }, { type: i5.CustomRadioButtonService }, { type: i6.DomSanitizer }, { type: i7.ToastrService }, { type: i8.FileUploadLibraryService }, { type: i9.ReferenceLibraryService }, { type: i10.DialogService }, { type: i0.ChangeDetectorRef }, { type: i11.ActivatedRoute }, { type: i1$1.MatDialog }]; }, { htmlRenderObj: [{
            type: Input
        }], group: [{
            type: Input
        }], inputParams: [{
            type: Input
        }], formBuilderInfo: [{
            type: Input
        }] }); })();

class NumberToWordsPipe {
    transform(value) {
        if (value && isInteger(value))
            return numToWords(value);
        return value;
    }
}
NumberToWordsPipe.ɵfac = function NumberToWordsPipe_Factory(t) { return new (t || NumberToWordsPipe)(); };
NumberToWordsPipe.ɵpipe = i0.ɵɵdefinePipe({ name: "numberToWords", type: NumberToWordsPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NumberToWordsPipe, [{
        type: Pipe,
        args: [{
                name: "numberToWords",
            }]
    }], null, null); })();
const isInteger = function (x) {
    return x % 1 === 0;
};
const arr = (x) => Array.from(x);
const num = (x) => Number(x) || 0;
const str = (x) => String(x);
const isEmpty = (xs) => xs.length === 0;
const take = (n) => (xs) => xs.slice(0, n);
const drop = (n) => (xs) => xs.slice(n);
const reverse = (xs) => xs.slice(0).reverse();
const comp = (f) => (g) => (x) => f(g(x));
const not = (x) => !x;
const chunk = (n) => (xs) => isEmpty(xs) ? [] : [take(n)(xs), ...chunk(n)(drop(n)(xs))];
// numToWords :: (Number a, String a) => a -> String
let numToWords = (n) => {
    let a = [
        "",
        "one",
        "two",
        "three",
        "four",
        "five",
        "six",
        "seven",
        "eight",
        "nine",
        "ten",
        "eleven",
        "twelve",
        "thirteen",
        "fourteen",
        "fifteen",
        "sixteen",
        "seventeen",
        "eighteen",
        "nineteen",
    ];
    let b = [
        "",
        "",
        "twenty",
        "thirty",
        "forty",
        "fifty",
        "sixty",
        "seventy",
        "eighty",
        "ninety",
    ];
    let g = [
        "",
        "thousand",
        "million",
        "billion",
        "trillion",
        "quadrillion",
        "quintillion",
        "sextillion",
        "septillion",
        "octillion",
        "nonillion",
    ];
    // this part is really nasty still
    // it might edit this again later to show how Monoids could fix this up
    let makeGroup = ([ones, tens, huns]) => {
        return [
            num(huns) === 0 ? "" : a[huns] + " hundred ",
            num(ones) === 0 ? b[tens] : (b[tens] && b[tens] + "-") || "",
            a[tens + ones] || a[ones],
        ].join("");
    };
    // "thousands" constructor; no real good names for this, i guess
    let thousand = (group, i) => (group === "" ? group : `${group} ${g[i]}`);
    // execute !
    if (typeof n === "number")
        return numToWords(String(n));
    if (n === "0")
        return "zero";
    return comp(chunk(3))(reverse)(arr(n))
        .map(makeGroup)
        .map(thousand)
        .filter(comp(not)(isEmpty))
        .reverse()
        .join(" ");
};

class LibCreateInvoiceModule {
}
LibCreateInvoiceModule.ɵfac = function LibCreateInvoiceModule_Factory(t) { return new (t || LibCreateInvoiceModule)(); };
LibCreateInvoiceModule.ɵmod = i0.ɵɵdefineNgModule({ type: LibCreateInvoiceModule });
LibCreateInvoiceModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            FormsModule,
            ReactiveFormsModule,
            MatIconModule,
            MatDividerModule,
            MatButtonModule,
            DeleteDialogLibraryModule,
            FileUploadModule,
            MatDialogModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LibCreateInvoiceModule, { declarations: [LibCreateInvoiceComponent, NumberToWordsPipe, TemplatePreviewDialog], imports: [PrimengLibraryModule,
        FormsModule,
        ReactiveFormsModule,
        MatIconModule,
        MatDividerModule,
        MatButtonModule,
        DeleteDialogLibraryModule,
        FileUploadModule,
        MatDialogModule], exports: [LibCreateInvoiceComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibCreateInvoiceModule, [{
        type: NgModule,
        args: [{
                declarations: [LibCreateInvoiceComponent, NumberToWordsPipe, TemplatePreviewDialog],
                imports: [
                    PrimengLibraryModule,
                    FormsModule,
                    ReactiveFormsModule,
                    MatIconModule,
                    MatDividerModule,
                    MatButtonModule,
                    DeleteDialogLibraryModule,
                    FileUploadModule,
                    MatDialogModule
                ],
                exports: [LibCreateInvoiceComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of lib-create-invoice
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LibCreateInvoiceComponent, LibCreateInvoiceModule, LibCreateInvoiceService, NumberToWordsPipe };
//# sourceMappingURL=lib-create-invoice.js.map
